import { DatePipe,formatCurrency,formatNumber } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, NgZone, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog,MatLegacyDialogRef as MatDialogRef,MatLegacyDialogState as MatDialogState } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { ChartData,ChartDataset,TooltipItem } from 'chart.js';
import { BehaviorSubject, combineLatest, firstValueFrom, Observable, of, Subject, switchMap, throwError } from 'rxjs';
import {
    distinctUntilChanged, filter, first, map, shareReplay, take,
    takeUntil, tap,
} from 'rxjs/operators';
import { MilestoneEntity } from 'src/app/dave-data-module/entities/milestone.entity';
import { MilestoneResolver } from 'src/app/dave-data-module/guards/milestone.resolver';
import { getMilestonesActive,getMilestonesFetched } from 'src/app/dave-data-module/State/selectors/milestone.selector';
import { BusinessVolumeCostStateEnum,BusinessVolumeStatusEnum,BusinessVolumeStatusEnumNameMap } from '../../../dave-data-module/entities/business-volume.entity';
import { ClockInTypeEntity,EnumClockInTypeSlug } from '../../../dave-data-module/entities/clock-in-type.entity';
import { EventEntity,EventStateEnum,EventStateEnumNameMap,taskEventStates } from '../../../dave-data-module/entities/event.entity';
import { LedgerImportDocumentTypes,LedgerImportStatusEnum } from "../../../dave-data-module/entities/ledger-import.entity";
import { QuantityTypeNames } from '../../../dave-data-module/entities/quantity-type.entity';
import { BusinessVolumeResolver } from '../../../dave-data-module/guards/business-volume.resolver';
import { ClockInTypeResolver } from '../../../dave-data-module/guards/clock-in-type.resolver';
import { WorkedTimesByIdsResolverWithoutRoute, WorkedTimesResolver } from '../../../dave-data-module/guards/worked-times.resolver';
import { State } from '../../../dave-data-module/State';
import { getAccountsReceivableLedgerById,getQuantityTypes } from '../../../dave-data-module/State/selectors/accounting.selector';
import { getBVCustomNameFetched,getBVCustomNamesActive } from '../../../dave-data-module/State/selectors/b-v-custom-name.selector';
import { getBusinessVolume,getBusinessVolumeFetched } from '../../../dave-data-module/State/selectors/business-volume.selector';
import { getClockInTypes,getClockInTypesFetched } from '../../../dave-data-module/State/selectors/clock-in-type.selectors';
import {
    getCommissionById, getCommissionDictionary,
    getCommissions, getCommissionsFetched,
} from '../../../dave-data-module/State/selectors/commission.selector';
import { getLedgerImports } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import {
    getWorkedTimesByCommissionId,
    selectAreCommissionsLoaded, selectWorkedTimesByCommissionIds,
} from '../../../dave-data-module/State/selectors/worked-times.selectors';
import { DaveFilePreviewComponent,DaveFilePreviewComponentDialogData } from '../../../dave-file-preview-dialog/components/dave-file-preview/dave-file-preview.component';
import {
    FilterOption,
    FILTER_TYPE_SEARCH_MULTI_SELECT,
    IFilterTypeSearchMultiSelectValue,
    FILTER_TYPE_BOOLEAN,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import { BreakpointObserverService } from '../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import { compareArrays, isNotNullOrUndefined } from '../../../helper/helper';
import { TaskPageMeta } from '../../../helper/page-metadata';
import { ProgressBarEvent } from '../../../progress-bar/progress-timeline.component';
import { CustomDoughnutChartOptions } from './components/doughnut-chart/doughnut-chart.component';
import { FilterCardComponent } from "../../../dave-utils-module/app-filter-module/filter-card/filter-card.component";
import { BVCustomNameResolver } from "../../../dave-data-module/guards/b-v-custom-name.resolver";
import { WorkedTimesEntity } from "../../../dave-data-module/entities/worked-times.entity";
import { getFetched$ } from "../../../dave-data-module/helper/helper";
import { PermissionService } from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import { Dictionary } from '@ngrx/entity/src/models';
import { BusinessVolumesDialogComponent, ExportBusinessVolumeDialogComponentDialogData } from 'src/app/detail-list-template-dialog/business-volumes-dialog/business-volumes-dialog.component';
import { AccountsReceivableLedgerEntity } from '../../../dave-data-module/entities/accounts-receivable-ledger.entity';
import { FilterTypes } from '../../../services/default-filter.service';
import {
    getEmployeeDictionary,
    getEmployeesFetched,
} from '../../../dave-data-module/State/selectors/employees.selectors';
import {
    getWorkDayDictionary,
    getWorkDaysFetched,
} from '../../../dave-data-module/State/selectors/work-day.selectors';
import {
    getJobSpecificationDictionary,
    getJobSpecificationFetched,
} from '../../../dave-data-module/State/selectors/job-specification.selector';
import { DoughnutChartWrapperComponent,DoughnutChartWrapperComponentDialogData } from './components/doughnut-wrapper-dialog/doughnut-chart-wrapper.component';
import { MilestoneModalComponent,MilestoneModalComponentDialogData } from "./components/milestone-modal/milestone-modal.component";
import { TaskBoardPopupComponent,TaskBoardPopupComponentDialogData } from './components/task-board-popup/task-board-popup.component';
import { UserToCommissionListComponent,UserToCommissionListComponentDialogData } from './components/user-to-commission-list/user-to-commission-list.component';
import {EventDataService} from '../../../dave-data-module/services/event.service-data-service';
import { EntityRoleEntity, EntityRolePermissionNameEnum } from '../../../dave-data-module/entities/entity-role.entity';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { ColorService } from '../../../services/color.service';
import {
    getUserToEventFetched,
    getUserToEvents,
} from '../../../dave-data-module/State/selectors/user-to-event.selector';
import { UserToEventTimeSpanStringToHours } from '../../../dave-data-module/entities/user-to-event.entity';
import { UserToEventResolver } from '../../../dave-data-module/guards/user-to-event.resolver';
import {
    getEventTypeFetched,
    getEventTypes,
    getEventTypesDictionary,
} from '../../../dave-data-module/State/selectors/event-type.selector';

interface bvFilter {
    customNames: IFilterTypeSearchMultiSelectValue[];
    commissions: IFilterTypeSearchMultiSelectValue<number>[];
    setOtherFilters: boolean,
}
interface timeFilter {
    subCommissions: IFilterTypeSearchMultiSelectValue<number>[];
    setOtherFilters: boolean,
}
interface taskFilter {
    subCommissions: IFilterTypeSearchMultiSelectValue<number>[];
    setOtherFilters: boolean,
}
const colors = {
    red: 'rgb(192,19,19)',
    orange: 'rgb(239,172,50)',
    yellow: 'rgb(189,204,53)',
    green: 'rgb(109,255,86)',
    darkGreen: 'rgb(80,155,56)',
    blue: 'rgb(82,166,248)',
    grey: '#a4a4a4',
    border: '#fafafa',
    Cyan: 'rgb(184,254,253)',
    pastellLavendel: 'rgb(214,151,245)',
};

const commissionPositionColors = [
    '#001F3F',
    '#003F7F',
    '#0057B8',
    '#0066FF',
    '#3399FF',
    '#66B2FF',
    '#99CCFF',
    '#CCE5FF',
    '#00A6A6',
    '#007A7A',
    '#4B4BFF',
    '#2E2E8F',
];
const clockInTypeColorSlugMap = new Map<EnumClockInTypeSlug, string>([
    [EnumClockInTypeSlug.workTime, colors.green],
    [EnumClockInTypeSlug.badWeather, colors.orange],
    [EnumClockInTypeSlug.drivingTime, colors.yellow],
    [EnumClockInTypeSlug.businessTrip, colors.blue],
    [EnumClockInTypeSlug.break, colors.grey],
    [EnumClockInTypeSlug.commissionWorkTime, colors.green],
    [EnumClockInTypeSlug.waitingTime, colors.Cyan],
    [EnumClockInTypeSlug.other, colors.pastellLavendel],
]);
function getColorClockInType(ct: ClockInTypeEntity) {
    if (ct.Slug && clockInTypeColorSlugMap.has(ct.Slug)) {
        return clockInTypeColorSlugMap.get(ct.Slug);
    }
    return colors.darkGreen;
}
const defaultDataset: Partial<ChartDataset<'doughnut', number[]>> = {
    hoverOffset: 4,
    borderWidth: 1,
    borderColor: colors.border,
};

const commissionWorkClockInTypes = [
    EnumClockInTypeSlug.commissionWorkTime,
    EnumClockInTypeSlug.workTime,
];
@Component({
    selector: 'app-commission-overview',
    templateUrl: './commission-overview.component.html',
    styleUrls: ['./commission-overview.component.scss'],
    providers: [DatePipe],
})
export class CommissionOverviewComponent implements OnInit, OnDestroy {
    @Input() set CommissionId(id: number) {
        if (id !== this.CommissionId$.value) {
            this.CommissionId$.next(id);
        }
    }
    get CommissionId() {
        return this.CommissionId$.value;
    }

    @ViewChild('taskChart') taskChart: DoughnutChartWrapperComponent;
    @ViewChild('timeChart') timeChart: DoughnutChartWrapperComponent;
    @ViewChild('bvChart') bvChart: DoughnutChartWrapperComponent;
    @ViewChild('bvCostChart') bvCostChart: DoughnutChartWrapperComponent;
    @ViewChild('listCardDialogFooter') listCardDialogFooter: TemplateRef<any>;
    @ViewChild('customNameIdsFormTemplate') customNameIdsFormTemplate: TemplateRef<any>;
    @ViewChild('bvFilter') bvFilter: FilterCardComponent;
    @ViewChild('costFilter') costFilter: FilterCardComponent;
    @ViewChild('timeFilter') timeFilter: FilterCardComponent;
    @ViewChild('taskFilter') taskFilter: FilterCardComponent;

    public TaskIcon = TaskPageMeta.Icon;
    private filePreviewDialog: MatDialogRef<any>;
    public BVListDialogRef: MatDialogRef<any>;
    private destroy$ = new Subject<void>();

    private taskIndexState = [
        {
            label: EventStateEnumNameMap.get(EventStateEnum.New),
            state: EventStateEnum.New,
            backgroundColor: colors.blue,
            borderColor: colors.border,
            onClick: () => this.openTaskPopup(EventStateEnum.New),
        },
        {
            label: EventStateEnumNameMap.get(EventStateEnum.InProgress),
            state: EventStateEnum.InProgress,
            backgroundColor: colors.orange,
            borderColor: colors.border,
            onClick: () => this.openTaskPopup(EventStateEnum.InProgress),
        },
        {
            label: EventStateEnumNameMap.get(EventStateEnum.Done),
            state: EventStateEnum.Done,
            backgroundColor: colors.green,
            borderColor: colors.border,
            onClick: () => this.openTaskPopup(EventStateEnum.Done),
        },
        {
            label: 'Überfällig',
            state: null,
            backgroundColor: colors.red,
            borderColor: colors.border,
            onClick: () => this.openTaskPopup(null, true),
        },
        {
            label: null,
            state: null,
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            onClick: () => {},
        },
    ];



    private clockInTypes$ = this.store.select(getClockInTypesFetched).pipe(
        tap((fetched) => {
            if (!fetched) {
                this.clockInTypeResolver.resolve();
            }
        }),
        filter((fetched) => !!fetched),
        switchMap(() => this.store.select(getClockInTypes)),
        map((types) => types.filter((t) => t.IsWorkingTime)),
    );
    public CommissionId$ = new BehaviorSubject<number>(null);

    private groupedClockInTypes$ = this.clockInTypes$.pipe(
        map((clockInTypes) => {
            const ret: ClockInTypeEntity[][] = [];
            clockInTypes
                .filter((t) => !commissionWorkClockInTypes.includes(t.Slug))
                .forEach((ct) => {
                    ret.push([ct]);
                });

            const commissionWorkClockIns = clockInTypes
                .filter((t) => commissionWorkClockInTypes.includes(t.Slug));
            if (commissionWorkClockIns.length) {
                ret.unshift(commissionWorkClockIns);
            }
            return ret;
        }),
        shareReplay({bufferSize: 1, refCount: true}),
    );
    // private workTimesByClockInTypesFromCommissionIds$ = (commissionIds: number[]) => combineLatest([
    //     getFetched$(this.store, getWorkedTimesFetched, getWorkedTimes, this.workedTimesResolver).pipe(
    //         map((wt) => {
    //             if (!commissionIds || commissionIds.length === 0) {
    //                 throw new Error('commissionIds must not be empty');
    //             }
    //             return wt.filter((w) => commissionIds.includes(w.CommissionId))
    //         })
    //     ),
    //     this.groupedClockInTypes$,
    // ]).pipe(
    //     map(([workedTimes, clockInTypes]) => {
    //         const ret: Array<{clockInTypes: ClockInTypeEntity[], timespan: number, workTimes: WorkedTimesEntity[]}> = clockInTypes
    //             .map((ct) => {
    //                 const wt = workedTimes.filter((wt) => ct.some(c => c.Id === wt.ClockInTypeId))
    //                 return {clockInTypes: ct, workTimes: wt, timespan: wt.reduce((sum, v) => sum + v.Timespan, 0)};
    //             });
    //         return ret;
    //     })
    // );
    private workTimesByClockInTypesFromCommissionIds$ = (commissionIds: number[]) =>
        combineLatest([
            (!commissionIds || commissionIds.length === 0
                    ? throwError(() => new Error('commissionIds must not be empty'))
                    : getFetched$(
                        this.store,
                        selectAreCommissionsLoaded(commissionIds),
                        selectWorkedTimesByCommissionIds(commissionIds),
                    )
            ),
                this.groupedClockInTypes$,
            ]).pipe(
                map(([workedTimes, clockInTypes]) => {
                    const ret: Array<{clockInTypes: ClockInTypeEntity[], timespan: number, workTimes: WorkedTimesEntity[]}> = clockInTypes
                        .map((ct) => {
                            const wt = workedTimes.filter((wt) => ct.some(c => c.Id === wt.ClockInTypeId))
                            return {clockInTypes: ct, workTimes: wt, timespan: wt.reduce((sum, v) => sum + v.Timespan, 0)};
                        });
                    return ret;
                })
            );

    private isSyncing = false;

    protected setTaskFilter(value: taskFilter){
        if(this.isSyncing) return;
        this.isSyncing = true;
        this.taskFilterValues$.next(value);
        if(value.setOtherFilters){
            this.bvFilterValues$.next({customNames: this.bvFilterValues$.value.customNames, commissions: value.subCommissions, setOtherFilters: this.bvFilterValues$.value.setOtherFilters})
            this.bvCostFilterValues$.next({customNames: this.bvCostFilterValues$.value.customNames, commissions: value.subCommissions, setOtherFilters: this.bvCostFilterValues$.value.setOtherFilters})
            this.timeFilterValues$.next({subCommissions: value.subCommissions, setOtherFilters: this.timeFilterValues$.value.setOtherFilters})
        }
        this.isSyncing = false;

    }

    protected setBvFilter(value: bvFilter){
        if(this.isSyncing) return;
        this.isSyncing = true;
        this.bvFilterValues$.next(value);
        if(value.setOtherFilters){
            this.taskFilterValues$.next({ subCommissions: value.commissions, setOtherFilters: this.taskFilterValues$.value.setOtherFilters})
            this.bvCostFilterValues$.next({customNames: value.customNames, commissions: value.commissions, setOtherFilters: this.bvCostFilterValues$.value.setOtherFilters})
            this.timeFilterValues$.next({subCommissions: value.commissions, setOtherFilters: this.timeFilterValues$.value.setOtherFilters})
        }
        this.isSyncing = false;

    }

    protected setBvCostFilter(value: bvFilter){
        if(this.isSyncing) return;
        this.isSyncing = true;
        this.bvCostFilterValues$.next(value);
        if(value.setOtherFilters){
            this.taskFilterValues$.next({ subCommissions: value.commissions, setOtherFilters: this.taskFilterValues$.value.setOtherFilters})
            this.bvFilterValues$.next({customNames: value.customNames, commissions: value.commissions, setOtherFilters: this.bvFilterValues$.value.setOtherFilters})
            this.timeFilterValues$.next({subCommissions: value.commissions, setOtherFilters: this.timeFilterValues$.value.setOtherFilters})
        }
        this.isSyncing = false;

    }

    protected setTimeFilter(value: timeFilter){
        if(this.isSyncing) return;
        this.isSyncing = true;
        this.timeFilterValues$.next(value);
        if(value.setOtherFilters){
            this.bvFilterValues$.next({customNames: this.bvFilterValues$.value.customNames, commissions: value.subCommissions, setOtherFilters: this.bvFilterValues$.value.setOtherFilters})
            this.bvCostFilterValues$.next({customNames: this.bvCostFilterValues$.value.customNames, commissions: value.subCommissions, setOtherFilters: this.bvCostFilterValues$.value.setOtherFilters})
            this.taskFilterValues$.next({subCommissions: value.subCommissions, setOtherFilters: this.taskFilterValues$.value.setOtherFilters})
        }
        this.isSyncing = false;

    }



    private businessVolumeIndexState$: Observable<{
        label: string;
        states: BusinessVolumeStatusEnum[];
        backgroundColor: string;
        borderColor: string;
        onClick: (type: BusinessVolumeCostStateEnum) => void
    }[]> = this.groupedClockInTypes$.pipe(
        map((types) => [
            {
                label: BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Payed),
                states: [BusinessVolumeStatusEnum.Payed],
                backgroundColor: colors.green,
                borderColor: colors.border,
                onClick: (type: BusinessVolumeCostStateEnum) => this.openBVPopup([BusinessVolumeStatusEnum.Payed], type),
            },
            {
                label: BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Open) + ' / ' + BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Booked),
                states: [BusinessVolumeStatusEnum.Open, BusinessVolumeStatusEnum.Booked],
                backgroundColor: colors.blue,
                borderColor: colors.border,
                onClick: (type: BusinessVolumeCostStateEnum) => this.openBVPopup([BusinessVolumeStatusEnum.Open, BusinessVolumeStatusEnum.Booked], type),
            },
            {
                label: BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Notbooked),
                states: [BusinessVolumeStatusEnum.Notbooked],
                backgroundColor: colors.orange,
                borderColor: colors.border,
                onClick: (type: BusinessVolumeCostStateEnum) => this.openBVPopup([BusinessVolumeStatusEnum.Notbooked], type),
            },
            {
                label: 'noch zu leisten',
                states: null,
                backgroundColor: colors.grey,
                borderColor: colors.border,
                onClick: null,
            },
            {
                label: 'Abweichung',
                states: null,
                backgroundColor: colors.red,
                borderColor: colors.border,
                onClick: null,
            },
            // ...types.map((v) => {
            //     const t = v.length === 1 ? v[0] : v.find((t) => t.Slug !== EnumClockInTypeSlug.commissionWorkTime);
            //     return {
            //         label: t.Name,
            //         states: null,
            //         // backgroundColor: getColorClockInType(t),
            //         backgroundColor: ThemePrimaryColours['user-theme'],
            //         borderColor: colors.border,
            //         onClick: null,
            //     }
            // }),
            {
                label: null,
                states: null,
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                onClick: (type: BusinessVolumeCostStateEnum) => {},
            },
        ]));
    private businessVolumeCostIndexState$: Observable<{
        label: string;
        state: BusinessVolumeStatusEnum;
        backgroundColor: string;
        borderColor: string;
        onClick: (type: BusinessVolumeCostStateEnum) => void
    }[]> = this.groupedClockInTypes$.pipe(
        map((types) => [
        {
            label: BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Payed),
            state: BusinessVolumeStatusEnum.Payed,
            backgroundColor: colors.green,
            borderColor: colors.border,
            onClick: (type: BusinessVolumeCostStateEnum) => this.openBVPopup([BusinessVolumeStatusEnum.Payed], type),
        },
        {
            label: BusinessVolumeStatusEnumNameMap.get(BusinessVolumeStatusEnum.Open),
            state: BusinessVolumeStatusEnum.Open,
            backgroundColor: colors.blue,
            borderColor: colors.border,
            onClick: (type: BusinessVolumeCostStateEnum) => this.openBVPopup([BusinessVolumeStatusEnum.Open], type),
        },
        {
            label: 'Abweichung',
            state: null,
            backgroundColor: colors.red,
            borderColor: colors.border,
            onClick: null,
        },

        // ...types.map((v) => {
        //     const t = v.length === 1 ? v[0] : v.find((t) => t.Slug !== EnumClockInTypeSlug.commissionWorkTime);
        //     return {
        //         label: t.Name,
        //         state: null,
        //         // backgroundColor: getColorClockInType(t),
        //         backgroundColor: ThemePrimaryColours['user-theme'],
        //         borderColor: colors.border,
        //         onClick: null,
        //     }
        // }),
        {
            label: null,
            state: null,
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            onClick: null,
        },
    ]));



    // private timeIndexState$ = this.groupedClockInTypes$.pipe(
    //     map((types) => [
    //         ...types.map((v) => {
    //             const t = v.length === 1 ? v[0] : v.find((t) => t.Slug !== EnumClockInTypeSlug.commissionWorkTime);
    //                 return {
    //                     label: t.Name,
    //                     backgroundColor: getColorClockInType(t),
    //                     borderColor: colors.border,
    //             }
    //             }),
    //         {
    //             label: 'Offen',
    //             backgroundColor: colors.grey,
    //             borderColor: colors.border,
    //         },
    //         {
    //             label: 'Abweichung',
    //             backgroundColor: colors.red,
    //             borderColor: colors.border,
    //         },
    //         {
    //             label: null,
    //             backgroundColor: 'transparent',
    //             borderColor: 'transparent',
    //         },
    //     ]),
    //     shareReplay({ refCount: true, bufferSize: 1 }),
    // );

    private timeIndexState :{
        label: string;
        backgroundColor: string;
        borderColor: string;
    }[] = [
        {
            label: 'Offen',
            backgroundColor: colors.grey,
            borderColor: colors.border,
        },
        {
            label: 'Abweichung',
            backgroundColor: colors.red,
            borderColor: colors.border,
        }
    ];

    public TimelineFillWidth$: Observable<{
        start: Date;
        end: Date;
        fillDate: Date;
        pointer$: Observable<ProgressBarEvent[]>;
    }> = this.CommissionId$.pipe(
        switchMap((id) => this.store.select(getCommissionById({ id }))),
        filter(isNotNullOrUndefined),
        map((commission) => {
            const start = commission.StartDate || commission.PlannedStartDate;
            const end = commission.EndDate || commission.PlannedEndDate;
            const now = new Date();
            if (start && end) {
                 var state = (date: Date): number => {
                    const v = 100 - ((end.getTime() - date.getTime()) / (end.getTime() - start.getTime())) * 100;
                    return v > 100 ? 100 : v < 0 ? 0 : v;
                };
                const d = new Date(start);
                const months: Date[] = [];
                if (start.getTime() < end.getTime()) {
                    while (d.getTime() < end.getTime()) {
                        d.setMonth(d.getMonth() + 1);
                        if (d.getTime() < end.getTime()) {
                            months.push(new Date(d.getFullYear(), d.getMonth()));
                        }
                    }
                }
            }

            const getPointer = (milestones: MilestoneEntity[], workTimes: WorkedTimesEntity[], events: Dictionary<EventEntity>): ProgressBarEvent[] => {
                return (
                    milestones
                        //.filter((e) => moment(e.Deadline).isBetween(start, end))
                        .sort((a, b) => {
                            if (a.Deadline == null && b.Deadline == null) {
                                return a.CreatedAt.getTime() - b.CreatedAt.getTime();
                            } else if (a.Deadline == null) {
                                return 1;
                            } else if (b.Deadline == null) {
                               return -1;
                            }
                            return a.Deadline.getTime() - b.Deadline.getTime()
                        })
                        .map((e, index) => {
                            const showProgress = e.ClockInTypeId && isNotNullOrUndefined(e.TargetHours);
                            const workedTimespan = showProgress && workTimes.filter(w => w.ClockInTypeId === e.ClockInTypeId && w.CommissionId === e.CommissionId).reduce((prev, curr) => prev + curr.Timespan, 0);
                            const workedHours = isNotNullOrUndefined(workedTimespan) ? workedTimespan / 1000 / 60 / 60 : null;
                            const tasks = e.EventIds?.map(id => events[id]).filter(e => e?.IsTask);
                            const doneTasks = tasks?.filter(t => t.State === EventStateEnum.Done);
                            const hasSubEvents = tasks?.length > 0;
                            return {
                                label: index + 1,
                                date: e.Deadline,
                                tooltip: e.Name,
                                state: e.State,
                                desc: e.Description,
                                entity: e,
                                progress: showProgress && workedHours,
                                progressTarget: e.TargetHours,
                                progressLabel: showProgress
                                    ? formatNumber(workedHours, this.locale, '1.0-2') + '/' + formatNumber(e.TargetHours, this.locale, '1.0-2') + ' Std.'
                                    : null,
                                progressDiffLabel: showProgress
                                    ? formatNumber(e.TargetHours - workedHours, this.locale, '1.0-2') + ' Std. verbleibend'
                                    : null,
                                subEventIcon: hasSubEvents ? TaskPageMeta.Icon : undefined,
                                subEventCount: hasSubEvents ? doneTasks?.length : undefined,
                                subEventCountTarget: hasSubEvents ? tasks?.length : undefined,
                            };
                        })
                    );
                }
                return {
                    fillDate: now,
                    fillState: state(now),
                    start,
                    end,

                    pointer$: combineLatest([
                        getFetched$(this.store, getMilestonesFetched, getMilestonesActive, this.mstr).pipe(map( milestones => milestones.filter((item) => item.CommissionId === commission.Id))),
                     //   getFetched$(this.store, getWorkedTimesFetched, getWorkedTimes).pipe(map(workedTimes => workedTimes.filter((item) => item.CommissionId === commission.Id))),
                        this.store.select(
                            getWorkedTimesByCommissionId(commission.Id)
                        ),
                        this.commissionEvents$,
                    ]).pipe(
                        map(([filteredMilestones, workedTimesFromCommission, events]) => {
                            return getPointer(filteredMilestones, workedTimesFromCommission, events);
                        }),
                    ),
                };
            }
        ),
    );
    public MilestoneClicked(conf?: MilestoneEntity) {
        this.dialog.open<MilestoneModalComponent, MilestoneModalComponentDialogData>(MilestoneModalComponent, {
            ...MilestoneModalComponent.DefaultConfig,
            data: {
                milestone: conf,
                createMilestoneMutationDefault: { commissionId: this.CommissionId },
                editMileStonePermission: this.EditMileStonePermission,
                deleteMilestonePermission: this.DeleteMileStonePermission,
            }
        })
        // const formMilestone = new FormGroup({
        //     Name: new FormControl<string>(conf?.Name),
        //     Description: new FormControl<string>(conf?.Description),
        //     Deadline: new FormControl<Moment>(moment(conf?.Deadline)),
        //     State: new FormControl<MilestoneEntityState>(conf?.State),
        // });
        // const ref = this.dialog.open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
        //     data: {
        //         Editing: true,
        //         DeleteButton: !!conf,
        //         DeleteButtonTooltip: 'Meilenstein löschen',
        //         Data: {
        //             Headline: conf ? conf.Name + ' bearbeiten' : 'Meilenstein erstellen',
        //             Properties: [
        //                 { key: 'Name', formControl: formMilestone.controls.Name },
        //                 {
        //                     key: 'Beschreibung',
        //                     formControl: formMilestone.controls.Description,
        //                     options: {
        //                         specialInput: {
        //                             textArea: { Fill: false },
        //                         },
        //                     },
        //                 },
        //                 {
        //                     key: 'Frist',
        //                     formControl: formMilestone.controls.Deadline,
        //                     options: {
        //                         specialInput: { date: true },
        //                     },
        //                 },
        //                 {
        //                     key: 'Status',
        //                     formControl: formMilestone.controls.State,
        //                     options: {
        //                         specialInput: { select: Object.values(MilestoneEntityState).map((val) => ({ optionLabel: MilestoneEntityStateNames.get(val), optionValue: val })) },
        //                     },
        //                 },
        //             ],
        //         },
        //     },
        // });
        // ref.afterClosed().subscribe((data) => {
        //     if (data?.Action === 'save') {
        //         if (conf) {
        //             this.store.dispatch(
        //                 MilestoneActionTypes.Change({
        //                     Payload: {
        //                         id: conf.Id,
        //                         deadline: formMilestone.value.Deadline && FrontendDate(formMilestone.value.Deadline.toDate()),
        //                         description: formMilestone.value.Description,
        //                         name: formMilestone.value.Name,
        //                         state: formMilestone.value.State as any,
        //                     },
        //                 }),
        //             );
        //         } else {
        //             this.store.dispatch(
        //                 MilestoneActionTypes.Create({
        //                     Payload: {
        //                         deadline: formMilestone.value.Deadline && FrontendDate(formMilestone.value.Deadline.toDate()),
        //                         description: formMilestone.value.Description,
        //                         name: formMilestone.value.Name,
        //                         state: formMilestone.value.State as any,
        //                         commissionId: this.CommissionId,
        //                     },
        //                 }),
        //             );
        //         }
        //     } else if (data?.Action === 'delete') {
        //         this.store.dispatch(
        //             MilestoneActionTypes.Delete({
        //                 Payload: {
        //                     id: conf.Id,
        //                 },
        //             }),
        //         );
        //     }
        // });
    }

    protected taskChartLegendValues: number[] = [];
    public TaskLabels = this.taskIndexState.map((t) => t.label).filter((v) => !!v);
    public TaskChartOptions: CustomDoughnutChartOptions = {
        responsive: true,
        onHover: function (e, elements) {
            (e.native.target as HTMLCanvasElement).style.cursor = elements[0] ? 'pointer' : 'default';
        },
        onClick: (e, el, chart) => {
            console.log(e)
            const activePoints = chart.getElementsAtEventForMode(
                e as any,
                'nearest',
                {
                    intersect: true,
                },
                false,
            );
            if (activePoints?.length) {
                const [{ index, datasetIndex }] = activePoints;
                this.taskIndexState[index].onClick();
            } else {
                this.taskChart?.OpenMeInPopUp();
            }
        },
        plugins: {
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: function(context) {
                    let tooltipEl = document.getElementById('chartjs-tooltip');
                    let tooltipContentEl = document.getElementById('chartjs-tooltip-content');

                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-tooltip';
                        document.body.appendChild(tooltipEl);

                        tooltipContentEl = document.createElement('div');
                        tooltipContentEl.id = 'chartjs-tooltip-content';
                        tooltipEl.appendChild(tooltipContentEl);
                    }

                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = '0';
                        return;
                    }

                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    if (tooltipModel.body) {
                        const bodyLines = tooltipModel.body.map(b => b.lines);

                        let innerHtml = '';
                        bodyLines.forEach(function(body, i) {
                            const colors = tooltipModel.labelColors[i];
                            let style = 'background: #495057';
                            style += '; color: #ffffff';
                            style += '; border-color: #000000';
                            style += '; border-width: 2px';
                            style += '; padding: 0.5rem';
                            style += '; border-radius: 5px';
                            style += '; word-wrap: break-word';
                            const colorSquare = '<span style="border: 2px solid #ffffff; display: inline-block; width: 12px; height: 12px; margin-right: 6px; background-color: ' + colors.backgroundColor + '"></span>';
                            innerHtml += '<div style="' + style + '">' + colorSquare + ' ' + body + '</div>';
                        });

                        tooltipContentEl.innerHTML = innerHtml;
                    }

                    const position = context.chart.canvas.getBoundingClientRect();
                    setTimeout(() => {
                        const tooltipWidth = tooltipEl.offsetWidth;
                        const tooltipHeight = tooltipEl.offsetHeight;
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        let left = position.left + tooltipModel.caretX;
                        if (left + tooltipWidth >= viewportWidth) {
                            left -= tooltipWidth;
                        }

                        let top = position.top + tooltipModel.caretY;
                        if (top + tooltipHeight >= viewportHeight) {
                            top -= tooltipHeight;
                        }
                        if (top < 0) {
                            top = 0;
                        }

                        tooltipEl.style.left = left + 'px';
                        tooltipEl.style.top = top + 'px';
                        tooltipEl.style.opacity = '1';
                        tooltipEl.style.position = 'fixed';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.zIndex = '2';
                    }, 0);
                },
                filter: (e: TooltipItem<'doughnut'>, index: number, array: TooltipItem<'doughnut'>[], data: ChartData) => {
                    return !!e.label;
                },
            },
            legend: {
                display: false,
            },
            htmlLegend: {
                display: true,
                showValue: true,
                legendValues: this.taskChartLegendValues,
            },
        },
    };


    public BusinessVolumeLabels$ = this.businessVolumeIndexState$.pipe(map(is => is.map((t) => t.label).filter((v) => !!v)));
    public BusinessVolumeCostsLabels$ = this.businessVolumeCostIndexState$.pipe(map(is => is.map((t) => t.label).filter((v) => !!v)));
    private bvsByCommission$ = this.store.select(getBusinessVolumeFetched).pipe(
        distinctUntilChanged(),
        tap((fetched) => {
            if (!fetched) {
                // this.businessVolumeResolver.resolve();
            }
        }),
        filter((v) => !!v),
        switchMap(() => this.CommissionId$),
        switchMap((commissionId) => this.store.select(getBusinessVolume).pipe(map((bvs) => bvs.filter((bv) => bv.CommissionId === commissionId)))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    private bvsFetched$ = getFetched$(this.store, getBusinessVolumeFetched, getBusinessVolume,this.businessVolumeResolver).pipe(
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public Commission$ = this.CommissionId$.pipe(
        switchMap((id) => this.store.select(getCommissionById({ id }))),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    protected taskFilterValues$ = new BehaviorSubject<taskFilter>({
        subCommissions: [],
        setOtherFilters: true,
    });
    protected bvFilterValues$ = new BehaviorSubject<bvFilter>({
        customNames: [],
        commissions: [],
        setOtherFilters: true,
    });
    protected bvCostFilterValues$ = new BehaviorSubject<bvFilter>({
        customNames: [],
        commissions: [],
        setOtherFilters: true,
    });
    protected timeFilterValues$ = new BehaviorSubject<timeFilter>({
        subCommissions: [],
        setOtherFilters: true,
    });
    protected taskFilterCount$ = this.taskFilterValues$.pipe(map((filter) => {
        let ret = 0;
        ret += filter?.subCommissions?.length ? 1 : 0;
        return ret || null;
    }));
    protected bvFilterCount$ = this.bvFilterValues$.pipe(map((filter) => {
        let ret = 0;
        ret += filter?.customNames?.length ? 1 : 0;
        ret += filter?.commissions?.length ? 1 : 0;
        return ret || null;
    }));
    protected bvCostFilterCount$ = this.bvCostFilterValues$.pipe(map((filter) => {
        let ret = 0;
        ret += filter?.customNames?.length ? 1 : 0;
        ret += filter?.commissions?.length ? 1 : 0;
        return ret || null;
    }));
    protected timeFilterCount$ = this.timeFilterValues$.pipe(map((filter) => (filter?.subCommissions?.length ? 1 : null)));

    private allRelevantCommissionIds$ = combineLatest([
        this.CommissionId$,
        this.store.select(getCommissionsFetched).pipe(filter(f => f)),
        this.store.select(getCommissions),
        this.bvFilterValues$,
        this.timeFilterValues$,
        this.taskFilterValues$,
        this.bvCostFilterValues$
    ]).pipe(
        map(([commissionId, _, commissions, bvFilter, timeFilter, taskFilter, bvCostFilter]) => {
            const childIds = commissions
                .filter(c => c.ParentId === commissionId)
                .map(c => c.Id);

            const filterIds = [
                ...(bvFilter?.commissions?.map(c => c.id) ?? []),
                ...(timeFilter?.subCommissions?.map(c => c.id) ?? []),
                ...(taskFilter?.subCommissions?.map(c => c.id) ?? []),
                ...(bvCostFilter?.commissions?.map(c => c.id) ?? [])
            ];

            const ids = [commissionId, ...childIds, ...filterIds];
            return [...new Set(ids.filter(isNotNullOrUndefined))].sort();
        }),
        distinctUntilChanged((a, b) => compareArrays(a, b)),
        shareReplay({bufferSize: 1, refCount: true})
    );

    private ensureWorkedTimesLoaded$ = this.allRelevantCommissionIds$.pipe(
        switchMap(ids => {
            if (ids.length === 0) return of(true);
            return WorkedTimesByIdsResolverWithoutRoute(this.store, this.workedTimesResolver, ids, []);
        }),
    );

    protected bvFilterSettings$: Observable<FilterOption<keyof bvFilter>[]> = combineLatest([
        getFetched$(this.store, getBVCustomNameFetched, getBVCustomNamesActive),
        combineLatest([getFetched$(this.store, getCommissionsFetched, getCommissions),this.CommissionId$]).pipe(
            map(([commissions, commissionId]) => commissions.filter(c => c.ParentId === commissionId))
        ),
        this.cls.getMultiple$('Commission'),
    ]).pipe(
        map(([customNames, childCommissions, commissionLabel]) => {
            const ret: FilterOption<keyof bvFilter>[] = [
                {
                    Name: 'customNames',
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Art',
                    Values: customNames.map((r) => ({
                        label: r.Name,
                        id: r.Id,
                    })),
                },
                {
                    Name: 'commissions',
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Teil'+commissionLabel.toLocaleLowerCase(),
                    Values: childCommissions.map((c) => ({
                        label: c.optionLabel,
                        id: c.Id,
                    })),
                },
                {
                    Name: 'setOtherFilters',
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Filter für alle diagramme übernehmen',
                },
            ];
            return ret;
        })
    );
    protected taskFilterSettings$: Observable<FilterOption<keyof taskFilter>[]> = combineLatest([
        combineLatest([getFetched$(this.store, getCommissionsFetched, getCommissions),this.CommissionId$]).pipe(
            map(([commissions, commissionId]) => commissions.filter(c => c.ParentId === commissionId))
        ),
        this.cls.getMultiple$('Commission'),
    ]).pipe(
        map(([childCommissions, commissionLabel]) => {
            const ret: FilterOption<keyof taskFilter>[] = [
                {
                    Name: 'subCommissions',
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Teil'+commissionLabel.toLocaleLowerCase(),
                    Values: childCommissions.map((c) => ({
                        label: c.optionLabel,
                        id: c.Id,
                    })),
                },
                {
                    Name: 'setOtherFilters',
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Filter für alle diagramme übernehmen',
                },
            ];
            return ret;
        })
    );
    protected bvCostFilterSettings$ = this.bvFilterSettings$;
    protected timeFilterSettings$: Observable<FilterOption<keyof timeFilter>[]> = combineLatest([
        combineLatest([getFetched$(this.store, getCommissionsFetched, getCommissions),this.CommissionId$]).pipe(
            map(([commissions, commissionId]) => commissions.filter(c => c.ParentId === commissionId))
        ),
        this.cls.getMultiple$('Commission'),
    ]).pipe(
        map(([childCommissions, commissionLabel]) => {
            const ret: FilterOption<keyof timeFilter>[] = [
                {
                    Name: 'subCommissions',
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Teil'+commissionLabel.toLocaleLowerCase(),
                    Values: childCommissions.map((c) => ({
                        label: c.optionLabel,
                        id: c.Id,
                    })),
                },
                {
                    Name: 'setOtherFilters',
                    Type: FILTER_TYPE_BOOLEAN,
                    Label: 'Filter für alle diagramme übernehmen',
                },
            ];
            return ret;
        })
    );
    // private bvsFilteredByTypeCommission$ = (BVType: BusinessVolumeCostStateEnum, filter$: Observable<Pick<bvFilter, 'commissions'>>) => this.bvsFetched$.pipe(
    //     map((bv) => bv.filter((b) => b.BVType === BVType && !!b.CommissionId)),
    //     distinctUntilChanged((a, b) =>
    //         a.length === b.length && a.every((entry, i) => entry.Id === b[i].Id && entry.UpdatedAt === b[i].UpdatedAt)),
    //     switchMap(bvs => combineLatest([this.CommissionId$, filter$]).pipe(
    //             map(([commissionId, filter]) => [commissionId].sort()),
    //             distinctUntilChanged(compareArrays),
    //             map(commissions => bvs.filter(bv => commissions.includes(bv.CommissionId))),
    //         )
    //     ),
    // );

    private commissionEvents$ = this.CommissionId$.pipe(
        filter(isNotNullOrUndefined),
        switchMap(id => this.eventDataService.GetFromCommissionDict$(id))
    );

    private bvsFilteredByTypeCommission$ = (BVType: BusinessVolumeCostStateEnum, commissionId: Observable<number>) => {
       return combineLatest([this.bvsFetched$, commissionId]).pipe(
            map(([bv, commissionId]) => bv.filter((b) => b.BVType === BVType && b.CommissionId === commissionId)),
            distinctUntilChanged((a, b) =>

                a.length === b.length && a.every((entry, i) => entry.Id === b[i].Id && entry.UpdatedAt === b[i].UpdatedAt))
        );
    }
    private bvsFilteredByIncomeTypeCommissions$ = this.bvsFilteredByTypeCommission$(BusinessVolumeCostStateEnum.Income, this.CommissionId$).pipe(
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    // private bvsFilteredByIncomeTypeCommissions$ = this.bvsFilteredByTypeCommission$(BusinessVolumeCostStateEnum.Income, this.bvFilterValues$).pipe(
    //     shareReplay({ refCount: true, bufferSize: 1 }),
    // );

    private bvsFilteredByCostTypeCommissions$ = this.bvsFilteredByTypeCommission$(BusinessVolumeCostStateEnum.Costs, this.CommissionId$).pipe(
        shareReplay({ refCount: true, bufferSize: 1 }),
    );



    public BusinessVolumeSum$ = this.bvsByCommission$.pipe(
        map(
            (bvs) =>
                bvs
                    .filter((f) => f.BVType === BusinessVolumeCostStateEnum.Income)
                    .reduce((sum, bv) => {
                        return sum + (bv.PayedAmount || 0);
                        // Auf Alex bitte hin angepasst
                        // if (bv.Status === BusinessVolumeStatusEnum.Booked) {
                        //     return sum + (bv.Amount || 0);
                        // } else if (bv.Status === BusinessVolumeStatusEnum.Open) {
                        //     return sum + (bv.PayedAmount || 0);
                        // }
                        // return sum;
                    }, 0) / 100,
        ),
    );
    public BusinessVolumeCostSum$ = this.bvsFilteredByCostTypeCommissions$.pipe(
        map(
            (bvs) =>
                bvs
                    .reduce((sum, bv) => {
                        if (bv.Status === BusinessVolumeStatusEnum.Payed) {
                            return sum + (bv.Amount || 0);
                        } else if (bv.Status === BusinessVolumeStatusEnum.Open) {
                            return sum + (bv.PayedAmount || 0);
                        }
                        return sum;
                    }, 0) / 100,
        ),
    );

    private baseTimesByCommission$ = combineLatest([
        this.CommissionId$,
        getFetched$(this.store, getCommissionsFetched, getCommissions),
        this.allRelevantCommissionIds$
    ]).pipe(
        switchMap(([commissionId, commissions, allRelevantIds]) => {
            const allCommissionIds = allRelevantIds;

            return combineLatest([
                this.workTimeCostsByCommission$(allCommissionIds),
                this.bvsGroupedByTypeCommission$(BusinessVolumeCostStateEnum.Income, allCommissionIds),
                this.bvsGroupedByTypeCommission$(BusinessVolumeCostStateEnum.Costs, allCommissionIds),
                this.businessVolumeIndexState$,
                this.businessVolumeCostIndexState$,
            ]).pipe(
                map(([costsByCommission, incomeByCommission, costsBvByCommission, biState, bcState]) =>
                    allCommissionIds.map(cId => {
                        const costs = costsByCommission.get(cId) ?? [];
                        const total = costs.reduce((s, c) => s + (c.SellPrice || 0), 0);
                        const totalCost = costs.reduce((s, c) => s + (c.Cost || 0), 0);
                        const commission = commissions.find(c => c.Id === cId);

                        const bvs = incomeByCommission.get(cId) ?? [];
                        const income = (
                            bvs.filter(t => biState[0].states.includes(t.Status)).reduce((s, bv) => s + (bv.PayedAmount || 0), 0) +
                            bvs.filter(t => biState[1].states.includes(t.Status)).reduce((s, bv) => s + (bv.Amount || 0), 0) +
                            bvs.filter(t => biState[2].states.includes(t.Status)).reduce((s, bv) => s + (bv.Amount || 0), 0)
                        ) / 100;

                        const bvsCosts = costsBvByCommission.get(cId) ?? [];
                        const costsBvs = (
                            bvsCosts.filter(t => t.Status === bcState[0].state).reduce((s, bv) => s + (bv.Amount || 0), 0) +
                            bvsCosts.filter(t => t.Status === bcState[1].state).reduce((s, bv) => s + (bv.Amount || 0), 0)
                        ) / 100;

                        return {
                            id: cId,
                            label: commission?.Auftragsnummer ?? commission?.optionLabel,
                            toolTip: commission?.optionLabel ?? `#${cId}`,
                            total,
                            types: [
                                { label: 'Personaleinnahmen', labelCost: 'Personalkosten', sellPrice: total, cost: totalCost },
                                { label: 'in Rechnung gestellt', labelCost: 'Kosten', sellPrice: income, cost: costsBvs },
                            ],
                            isMain: cId === commissionId,
                        };
                    })
                )
            );
        }),
        shareReplay(1)
    );


    private bvsGroupedByTypeCommission$ = (
        BVType: BusinessVolumeCostStateEnum,
        commissionIds: number[]
    ): Observable<Map<number, AccountsReceivableLedgerEntity[] extends never ? any : any>> => this.bvsFetched$.pipe(
        map(bvs => {
            const filtered = bvs.filter(b => b.BVType === BVType && commissionIds.includes(b.CommissionId));
            const grouped = new Map<number, typeof filtered>();
            filtered.forEach(bv => {
                const arr = grouped.get(bv.CommissionId) ?? [];
                arr.push(bv);
                grouped.set(bv.CommissionId, arr);
            });
            return grouped;
        }),
        distinctUntilChanged((a, b) => {
            const flatA = Array.from(a.values()).flat();
            const flatB = Array.from(b.values()).flat();
            return flatA.length === flatB.length && flatA.every((e, i) => e.Id === flatB[i]?.Id && e.UpdatedAt === flatB[i]?.UpdatedAt);
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    private workTimeCostsByCommission$ = (
        commissionIds: number[]
    ): Observable<Map<number, Array<{ ct: ClockInTypeEntity, Cost: number, SellPrice: number }>>> => combineLatest([
        this.workTimesByClockInTypesFromCommissionIds$(commissionIds),
        getFetched$(this.store, getEmployeesFetched, getEmployeeDictionary),
        getFetched$(this.store, getWorkDaysFetched, getWorkDayDictionary),
        getFetched$(this.store, getJobSpecificationFetched, getJobSpecificationDictionary),
    ]).pipe(
        map(([workTimesByClockInTypes, employees, workdays, jobs]) => {
            const byCommission = new Map<number, Map<number, { ct: ClockInTypeEntity, Cost: number, SellPrice: number }>>();

            workTimesByClockInTypes.forEach(w => {
                w.workTimes.forEach(wt => {
                    const employeeId = workdays[wt.WorkDayId]?.EmployeeId;
                    const employee = employeeId && employees[employeeId];
                    const employeeJob = employee?.JobSpecificationId && jobs[employee.JobSpecificationId];
                    if (!employeeJob) return;

                    const workingHours = wt.Timespan / 1000 / 60 / 60;
                    const cost = workingHours * (employeeJob.Amount || 0);
                    const sellPrice = workingHours * (employeeJob.SellingPrice || 0);

                    let byType = byCommission.get(wt.CommissionId);
                    if (!byType) {
                        byType = new Map();
                        byCommission.set(wt.CommissionId, byType);
                    }
                    const existing = byType.get(wt.ClockInTypeId);
                    if (existing) {
                        existing.Cost += cost;
                        existing.SellPrice += sellPrice;
                    } else {
                        byType.set(wt.ClockInTypeId, {
                            ct: w.clockInTypes.find(cit => cit.Id === wt.ClockInTypeId),
                            Cost: cost,
                            SellPrice: sellPrice,
                        });
                    }
                });
            });

            const result = new Map<number, Array<{ ct: ClockInTypeEntity, Cost: number, SellPrice: number }>>();
            byCommission.forEach((byType, cId) => result.set(cId, Array.from(byType.values())));
            return result;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );



    public BusinessVolumeDataSets$: Observable<ChartDataset<'doughnut', number[]>[]> = combineLatest([
        this.Commission$,
        this.bvsFilteredByIncomeTypeCommissions$.pipe(
            switchMap((bvs) => this.bvFilterValues$.pipe(map((filter) => (filter.customNames?.length ? bvs?.filter((bv) => bv.BVCustomNamesIds?.some((id) => filter.customNames.some((cn) => cn.id === id))) : bvs)))),
        ),
        //this.groupedClockInTypes$,
        combineLatest([this.bvFilterValues$, this.CommissionId$]).pipe(
            switchMap(([filter, commissionId]) => {
                const allIds = [commissionId, ...filter?.commissions?.map(({id}) => id) ?? []].filter(isNotNullOrUndefined);
                return this.workTimeCostsByCommission$(allIds);
            })
        ),
        this.businessVolumeIndexState$,
        this.bvFilterValues$,
        getFetched$(this.store, getCommissionsFetched, getCommissions),
        this.bvFilterValues$.pipe(
            switchMap((filter) => {
                const allIds = [...filter?.commissions?.map(({id}) => id) ?? []].filter(isNotNullOrUndefined);
                if (allIds.length === 0) return of([]);
                return combineLatest(
                    allIds.map(cId => this.bvsFilteredByTypeCommission$(BusinessVolumeCostStateEnum.Income, of(cId)))
                ).pipe(
                    map(bvsPerCommission => bvsPerCommission.flat())
                );
            })
        ),
    ]).pipe(
        map(([commission, bvs,  workTimeCosts, businessVolumeIndexState, filter, commissions, bvsByCommission]) => {
            const dataPayed = bvs.filter((t) => businessVolumeIndexState[0].states.includes(t.Status)).reduce((sum, bv) => sum + bv.PayedAmount, 0);
            const dataOpenOrBooked = bvs.filter((t) => businessVolumeIndexState[1].states.includes(t.Status)).reduce((sum, bv) => sum + bv.Amount, 0);
            const dataNotBooked = bvs.filter((t) => businessVolumeIndexState[2].states.includes(t.Status)).reduce((sum, bv) => sum + bv.Amount, 0);
            const target = commission.CompleteBusinessVolume || 0;



            const subDataPayed = bvsByCommission.filter((t) => businessVolumeIndexState[0].states.includes(t.Status)).reduce((sum, bv) => sum + bv.PayedAmount, 0);
            const subDataOpenOrBooked = bvsByCommission.filter((t) => businessVolumeIndexState[1].states.includes(t.Status)).reduce((sum, bv) => sum + bv.Amount, 0);
            const subDataNotBooked = bvsByCommission.filter((t) => businessVolumeIndexState[2].states.includes(t.Status)).reduce((sum, bv) => sum + bv.Amount, 0);

            const totalPayed = dataPayed + subDataPayed;
            const totalOpenOrBooked = dataOpenOrBooked + subDataOpenOrBooked;
            const totalNotBooked = dataNotBooked + subDataNotBooked;

            const missing = (target - (totalPayed + totalOpenOrBooked + totalNotBooked)) / 100;
            const toMuch = (totalPayed + totalOpenOrBooked + totalNotBooked - target) / 100;


            const subTotalsByCommission = filter?.commissions?.map(({ id }) => {
                const payed = bvsByCommission
                    .filter(bv => bv.CommissionId === id && businessVolumeIndexState[0].states.includes(bv.Status))
                    .reduce((sum, bv) => sum + bv.PayedAmount, 0);
                const openOrBooked = bvsByCommission
                    .filter(bv => bv.CommissionId === id && businessVolumeIndexState[1].states.includes(bv.Status))
                    .reduce((sum, bv) => sum + bv.Amount, 0);
                const notBooked = bvsByCommission
                    .filter(bv => bv.CommissionId === id && businessVolumeIndexState[2].states.includes(bv.Status))
                    .reduce((sum, bv) => sum + bv.Amount, 0);
                const total = payed + openOrBooked + notBooked;
                const label = commissions.find(c => c.Id === id)?.optionLabel ?? `#${id}`;
                return { id, label, total };
            }) ?? [];




            const getDataArray = ({payed,openOrBooked,notBooked,zuLeisten,abweichung,workTimes, spacer}: {payed?: number, openOrBooked?:number, notBooked?:number, zuLeisten?: number, abweichung?: number, workTimes?: number[], spacer?: number}) => [
                payed || 0,
                openOrBooked || 0,
                notBooked || 0,
                zuLeisten || 0,
                abweichung || 0,
                //...(workTimes || workTimesByClockInTypes.map(() => 0)),
                spacer || 0,
            ]

            const allCommissionIds = [this.CommissionId, ...filter?.commissions?.map(({ id }) => id) ?? []].filter(isNotNullOrUndefined);

          //  const mainCommissionCosts = workTimeCosts.find(w => w.commissionId === this.CommissionId)?.costs ?? [];
          //  const subCommissionIds = allCommissionIds.slice(1);
            const commissionEntries = allCommissionIds.map((cId, i) => {
                const costs = workTimeCosts.get(cId) ?? [];
                return {
                    data: costs.reduce((sum, c) => sum + (c.SellPrice || 0), 0),
                    label: commissions.find(c => c.Id === cId)?.optionLabel ?? `#${cId}`,
                    color: this.getCommissionColor(i),
                };
            });

            const ring2Sum = commissionEntries.reduce((sum, e) => sum + e.data, 0);
            const targetRing2 = (target / 100) - ring2Sum;

            const ring2Entries = [
                // ...mainCommissionCosts.map(c => ({
                //     data: c.SellPrice,
                //     label: c.ct.Name,
                //     color: this.getCommissionColor(0),
                // })),
                ...commissionEntries,
                {
                    data: targetRing2 > 0 ? targetRing2 : 0,
                    label: '',
                    color: 'transparent',
                },
            ];


            const ring2Data = ring2Entries.map(e => e.data);
            const ring1Labels = [
                `${businessVolumeIndexState[0].label}: ${formatCurrency(dataPayed / 100, 'de-DE', '€')}`,
                `${businessVolumeIndexState[1].label}: ${formatCurrency(dataOpenOrBooked / 100, 'de-DE', '€')}`,
                `${businessVolumeIndexState[2].label}: ${formatCurrency(dataNotBooked / 100, 'de-DE', '€')}`,
                `${businessVolumeIndexState[3].label}: ${formatCurrency(missing < 0 ? 0 : missing, 'de-DE', '€')}`,
                null, // abweichung
                null, // spacer
                // Sub-Commissions:
                ...subTotalsByCommission.map(s =>
                    `${s.label +" in Rechnung gestellt"}: ${formatCurrency(s.total / 100, 'de-DE', '€')}`
                ),
            ];


            const ring2Labels = ring2Entries.map(e =>
                e.label ? `${e.label + " Personaleinnahmen"}: ${formatCurrency(e.data, 'de-DE', '€')}` : null
            ) ;

            const ring3Labels = [
                null, // payed
                null, // openOrBooked
                null, // notBooked
                null, // zuLeisten
                `Abweichung: ${formatCurrency(toMuch > 0 ? toMuch : 0, 'de-DE', '€')}`,
                null, // spacer
            ] ;

            this.bvIncomeLegendValues.splice(0, this.bvIncomeLegendValues.length,
                dataPayed / 100,
                dataOpenOrBooked / 100,
                dataNotBooked / 100,
                missing < 0 ? 0 : missing,
                toMuch > 0 ? toMuch : 0,
                0,
            );

            const allDataSets =  [
                {
                    ...defaultDataset,
                    data: [
                        ...getDataArray({
                            payed: dataPayed / 100,
                            openOrBooked: dataOpenOrBooked / 100,
                            notBooked: dataNotBooked / 100,
                            zuLeisten: missing < 0 ? 0 : missing,
                        }),
                        ...subTotalsByCommission.map(s => s.total / 100),
                    ],
                    backgroundColor: [
                        ...businessVolumeIndexState.map((t) => t.backgroundColor),
                        ...subTotalsByCommission.map((_, i) => this.getCommissionColor(i + 1)),
                    ],
                    borderColor: colors.border,
                    labels: ring1Labels,
                },
                {
                    ...defaultDataset,
                    data: ring2Data,
                    backgroundColor: ring2Entries.map(e => e.color),
                    borderColor: colors.border,
                    labels: ring2Labels,
                    weight: 0.75,
                },
                {
                    ...defaultDataset,
                    data: getDataArray({
                        abweichung: toMuch > 0 ? toMuch : 0,
                        spacer: target / 100,
                    }),
                    backgroundColor: businessVolumeIndexState.map((t) => t.backgroundColor),
                    borderColor: businessVolumeIndexState.map(t =>
                        t.backgroundColor === 'transparent' ? 'transparent' : colors.border
                    ),
                    weight: 0.75,
                    labels: ring3Labels
                },
            ];

            return allDataSets.filter((ds, index) => {
                if (index === 2) return ds.data.slice(0, -1).some(v => v > 0); // Ring 3: letzten ignorieren damit kein leerer abweichungs ring erscheint
                return ds.data.some(v => v > 0);
            })
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    // protected TimesByCommission$ = combineLatest([
    //     this.bvFilterValues$,
    //     this.CommissionId$,
    //     getFetched$(this.store, getCommissionsFetched, getCommissionsActive),
    // ]).pipe(
    //     switchMap(([filter, commissionId, commissions]) => {
    //         const selectedSubIds = filter?.commissions?.map(({ id }) => id) ?? [];
    //
    //
    //         const allIds = [commissionId, ...selectedSubIds].filter(isNotNullOrUndefined);
    //
    //         return combineLatest([
    //             this.workTimesByClockInTypesFromCommissionIds$(allIds),
    //             this.workTimeCosts$(allIds),
    //         ]).pipe(
    //             map(([workedTimesByClockInType, workTimeCosts]) => {
    //                 return allIds.map((cId, index) => {
    //                     const costsPerType = workedTimesByClockInType.map(group => ({
    //                         label: group.clockInTypes.length === 1
    //                             ? group.clockInTypes[0].Name
    //                             : group.clockInTypes.find(t => t.Slug !== EnumClockInTypeSlug.commissionWorkTime)?.Name,
    //                         sellPrice: group.workTimes
    //                             .filter(wt => wt.CommissionId === cId)
    //                             .reduce((sum, wt) => {
    //                                 const cost = workTimeCosts.find(c => c.ct.Id === wt.ClockInTypeId);
    //                                 const totalTimespan = group.workTimes
    //                                     .filter(w => w.ClockInTypeId === wt.ClockInTypeId)
    //                                     .reduce((s, w) => s + w.Timespan, 0);
    //                                 const fraction = totalTimespan > 0 ? wt.Timespan / totalTimespan : 0;
    //                                 return sum + (cost?.SellPrice || 0) * fraction;
    //                             }, 0),
    //                     })).filter(t => t.sellPrice > 0);
    //
    //                     const total = costsPerType.reduce((sum, t) => sum + t.sellPrice, 0);
    //                     const isMain = cId === commissionId;
    //
    //                     return {
    //                         label: commissions.find(c => c.Id === cId)?.optionLabel ?? `#${cId}`,
    //                         total,
    //                         types: isMain ? costsPerType : [{ label: 'Personalkosten', sellPrice: total }],
    //                         color: this.getCommissionColor(index),
    //                         isMain,
    //                     };
    //                 }).filter(g => g.total > 0);
    //
    //             })
    //         );
    //     })
    // );


    private baseTimesHoursByCommission$ = combineLatest([
        this.CommissionId$,
        getFetched$(this.store, getCommissionsFetched, getCommissions),
        this.allRelevantCommissionIds$
    ]).pipe(
        switchMap(([commissionId, commissions, allRelevantIds]) => {

            const allCommissionIds = allRelevantIds;

            return combineLatest([
                this.workTimesByClockInTypesFromCommissionIds$(allCommissionIds),
            ]).pipe(
                map(([workedTimesByClockInType]) => {

                    return allCommissionIds.map((cId) => {

                        const hoursPerType = workedTimesByClockInType
                            .map(group => {

                                const clockinType = group.clockInTypes.length === 1
                                    ? group.clockInTypes[0]
                                    : group.clockInTypes.find(
                                        t => t.Slug !== EnumClockInTypeSlug.commissionWorkTime
                                    )
                                const label = clockinType?.Name;


                                const hours = group.workTimes
                                    .filter(wt => wt.CommissionId === cId)
                                    .reduce((sum, wt) => {
                                        return sum + (wt.Timespan / 1000 / 60 / 60);
                                    }, 0);

                                const color = getColorClockInType(clockinType)

                                return {
                                    label,
                                    hours,
                                    color,
                                };
                            })

                        const total = hoursPerType.reduce(
                            (sum, t) => sum + t.hours,
                            0
                        );

                        const isMain = cId === commissionId;

                        const commission = commissions.find(c => c.Id === cId)

                        return {
                            id: cId,
                            toolTip: commission?.optionLabel ?? `#${cId}`,
                            label: commission?.Auftragsnummer ?? commission?.optionLabel,
                            total, // HOURS
                            types: isMain
                                ? hoursPerType
                                : [{ label: 'Arbeitszeit', hours: total, color:"" }],
                            isMain,
                        };
                    });
                })
            );
        }),
        shareReplay({ bufferSize: 1, refCount: true })
    );

    protected TimesByCommissionHours$ = combineLatest([
        this.baseTimesHoursByCommission$,
        this.timeFilterValues$,
        this.CommissionId$
    ]).pipe(
        map(([groups, filter, commissionId]) => {

            const selectedSubIds =
                filter?.subCommissions?.map(({ id }) => id) ?? [];

            const allowedIds = [commissionId, ...selectedSubIds];

            return groups
                .filter(g => allowedIds.includes(g.id))
                .sort((a, b) => Number(b.isMain) - Number(a.isMain))
                .map((g, index) => ({
                    ...g,
                    color: this.getCommissionColor(index),
                }));
        })
    )




    protected TimesByCommission$ = combineLatest([
        this.baseTimesByCommission$,
        this.bvFilterValues$
    ]).pipe(
        map(([groups, filter]) => {
            const selectedSubIds = filter?.commissions?.map(({ id }) => id) ?? [];
            return groups
                .filter(g => [this.CommissionId, ...selectedSubIds].includes(g.id))
                .sort((a, b) => Number(b.isMain) - Number(a.isMain))
                .map((g, index) => ({ ...g, color: this.getCommissionColor(index) }));
        })
    );

    protected TimesByCommissionCostsFilter$ = combineLatest([
        this.baseTimesByCommission$,
        this.bvCostFilterValues$
    ]).pipe(
        map(([groups, filter]) => {
            const selectedSubIds = filter?.commissions?.map(({ id }) => id) ?? [];
            return groups
                .filter(g => [this.CommissionId, ...selectedSubIds].includes(g.id))
                .sort((a, b) => Number(b.isMain) - Number(a.isMain))
                .map((g, index) => ({ ...g, color: this.getCommissionColor(index) }));
        })

    );



    public BusinessVolumeCostDataSets$: Observable<ChartDataset<'doughnut', number[]>[]> = combineLatest([
        this.Commission$,
        this.bvsFilteredByCostTypeCommissions$.pipe(
            switchMap((bvs) => this.bvCostFilterValues$.pipe(map((filter) => (filter.customNames?.length ? bvs?.filter((bv) => bv.BVCustomNamesIds?.some((id) => filter.customNames.some((cn) => cn.id === id))) : bvs)))),
        ),
        this.groupedClockInTypes$, // für die richtige reihenfolge
        combineLatest([this.bvCostFilterValues$, this.CommissionId$]).pipe(
            switchMap(([filter, commissionId]) => {
                const allIds = [commissionId, ...filter?.commissions?.map(({id}) => id) ?? []].filter(isNotNullOrUndefined);
                return this.workTimeCostsByCommission$(allIds);
            })
        ),
        this.businessVolumeCostIndexState$,
        this.bvCostFilterValues$,
        getFetched$(this.store, getCommissionsFetched, getCommissions),
        this.bvCostFilterValues$.pipe(
            switchMap((filter) => {
                const allIds = [...filter?.commissions?.map(({id}) => id) ?? []].filter(isNotNullOrUndefined);
                if (allIds.length === 0) return of([] as any[]);
                return this.bvsGroupedByTypeCommission$(BusinessVolumeCostStateEnum.Costs, allIds).pipe(
                    map(grouped => Array.from(grouped.values()).flat())
                );
            })
        ),
    ]).pipe(
        map(([commission, bvs, workTimesByClockInTypes, workTimeCosts, businessVolumeCostIndexState, filter, commissions, bvsByCommission]) => {
            const data1 = bvs.filter((t) => t.Status === businessVolumeCostIndexState[0].state).reduce((sum, bv) => sum + bv.Amount, 0);
            const data2 = bvs.filter((t) => t.Status === businessVolumeCostIndexState[1].state).reduce((sum, bv) => sum + bv.Amount, 0);
            const target = commission.CostsCompleteBusinessVolume || 0;


            const subData1 = bvsByCommission.filter((t) => t.Status === businessVolumeCostIndexState[0].state).reduce((sum, bv) => sum + bv.Amount, 0);
            const subData2 = bvsByCommission.filter((t) => t.Status === businessVolumeCostIndexState[1].state).reduce((sum, bv) => sum + bv.Amount, 0);

            const totalData1 = data1 + subData1;
            const totalData2 = subData2 + data2;



            let missing = (target - (totalData1 + totalData2)) / 100;
            const toMuch = missing * -1;


            const getDataArray = ({payed, open, abweichung, workTimes, spacer}: {payed?: number, open?:number, abweichung?: number, workTimes?: number[], spacer?: number}) => [
                payed || 0,
                open || 0,
                abweichung || 0,
                ...(workTimes || workTimesByClockInTypes.map(() => 0)),
                spacer || 0,
            ]


            const allCommissionIds = [this.CommissionId, ...filter?.commissions?.map(({ id }) => id) ?? []].filter(isNotNullOrUndefined);
          //  const mainCommissionCosts = workTimeCosts.find(w => w.commissionId === this.CommissionId)?.costs ?? [];
         //   const subCommissionIds = allCommissionIds.slice(1);

            const subTotalsByCommission = filter?.commissions?.map(({ id }) => {
                const data1 = bvsByCommission
                    .filter(bv =>
                        bv.CommissionId === id &&
                        bv.Status === businessVolumeCostIndexState[0].state
                    )
                    .reduce((sum, bv) => sum + bv.Amount, 0);

                const data2 = bvsByCommission
                    .filter(bv =>
                        bv.CommissionId === id &&
                        bv.Status === businessVolumeCostIndexState[1].state
                    )
                    .reduce((sum, bv) => sum + bv.Amount, 0);

                const data = data1 + data2;

                const label =
                    commissions.find(c => c.Id === id)?.optionLabel ?? `#${id}`;

                const colorIndex = allCommissionIds.findIndex(cId => cId === id);

                return {
                    id,
                    label,
                    data,
                    color: this.getCommissionColor(colorIndex),
                };
            }) ?? [];

            const ring1Entries = [
                // ...mainCommissionCosts.map(c => ({
                //     data: c.Cost,
                //     label: c.ct.Name,
                //     color: this.getCommissionColor(0),
                // })),
                ...allCommissionIds.map((cId, i) => {
                    const costs = workTimeCosts.get(cId) ?? [];
                    const totalCost = costs.reduce((sum, c) => sum + (c.Cost || 0), 0) ?? 0;

                    missing -= totalCost;

                    return {
                        data: totalCost,
                        label: commissions.find(c => c.Id === cId)?.optionLabel ?? `#${cId}`,
                        color: this.getCommissionColor(i),
                    };
                }),
            ].filter(e => e.data > 0);
            this.bvCostsLegendValues.splice(0, this.bvCostsLegendValues.length,
                data1 / 100,
                data2 / 100,
                toMuch > 0 ? toMuch : 0,
                ...ring1Entries.map(e => e.data),
                0,
            );
            const ring1Labels = [
                `${businessVolumeCostIndexState[0].label}: ${formatCurrency(data1 / 100, 'de-DE', '€')}`,
                `${businessVolumeCostIndexState[1].label}: ${formatCurrency(data2 / 100, 'de-DE', '€')}`,
                null, // abweichung (Ring 2)
                ...ring1Entries.map(e => `${e.label + " Personalkosten"}: ${formatCurrency(e.data, 'de-DE', '€')}`),
                ...subTotalsByCommission.map(s => `${s.label + " Kosten"}: ${formatCurrency(s.data / 100, 'de-DE', '€')}`),
                null, // spacer
            ];

            const ring2Labels = [
                null, // payed
                null, // open
                `Abweichung: ${formatCurrency(toMuch > 0 ? toMuch : 0, 'de-DE', '€')}`,
                ...ring1Entries.map(() => null),
                null, // spacer
            ];
            const allDataSets = [
                {
                    ...defaultDataset,
                    data: getDataArray({
                        payed: data1 / 100,
                        open: data2 / 100,
                        abweichung: 0,
                        spacer: missing < 0 ? 0 : missing,
                        workTimes: [
                            ...ring1Entries.map(e => e.data),
                            ...subTotalsByCommission.map(s => s.data / 100),
                        ],
                    }),
                    backgroundColor: [
                        ...businessVolumeCostIndexState.slice(0, 3).map(t => t.backgroundColor),
                        ...ring1Entries.map(e => e.color),
                        ...subTotalsByCommission.map(e => e.color),
                        'transparent',
                    ],
                    borderColor: colors.border,
                    labels: ring1Labels,
                },
                {
                    ...defaultDataset,
                    data: getDataArray({
                        payed: 0,
                        open: 0,
                        abweichung: toMuch > 0 ? toMuch : 0,
                        spacer: target / 100 - toMuch > 0 ? target / 100 - toMuch : 0
                    }),
                    backgroundColor: [
                        'transparent',                           // payed
                        'transparent',                           // open
                        colors.red,                              // abweichung
                        ...ring1Entries.map(() => 'transparent'), // ring1-Slots transparent
                        'transparent',                           // spacer
                    ],
                    borderColor: [
                        'transparent',
                        'transparent',
                        colors.border,
                        ...ring1Entries.map(() => 'transparent'),
                        'transparent',
                    ],
                    weight: 0.75,
                    labels: ring2Labels,
                },
            ];
            return allDataSets.filter((ds, index) => {
                if (index === 1) return ds.data.slice(0, -1).some(v => v > 0); // Ring 2: letzten ignorieren damit kein leerer abweichungs ring erscheint
                return ds.data.some(v => v > 0);
            })
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    private bvIncomeLegendValues: number[] = [];
    private bvCostsLegendValues: number[] = [];

    private businessVolumeChartOptions = (type: BusinessVolumeCostStateEnum, indexState: Array<{onClick: (type: BusinessVolumeCostStateEnum) => void}>) => ({
        onHover: (e, elements) => {
            (e.native.target as HTMLCanvasElement).style.cursor =
                elements[0] && indexState[elements[0].index]?.onClick ? 'pointer' : 'default';
        },
        onClick: (e, el, chart) => {
            console.log({ e, el, chart });
            const activePoints = chart.getElementsAtEventForMode(
                e as any,
                'nearest',
                {
                    intersect: true,
                },
                false,
            );
            if (activePoints?.length) {
                const [{ index, datasetIndex }] = activePoints;
                if (indexState[index]?.onClick) {
                    indexState[index].onClick(type);
                }
            } else {
                if (type === BusinessVolumeCostStateEnum.Income) {
                    this.bvChart?.OpenMeInPopUp();
                } else if (type === BusinessVolumeCostStateEnum.Costs) {
                    this.bvCostChart?.OpenMeInPopUp();
                }
            }
        },
        responsive: true,
        plugins: {
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: function(context) {
        let tooltipEl = document.getElementById('chartjs-tooltip');
        let tooltipContentEl = document.getElementById('chartjs-tooltip-content');

        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            document.body.appendChild(tooltipEl);

            tooltipContentEl = document.createElement('div');
            tooltipContentEl.id = 'chartjs-tooltip-content';
            tooltipEl.appendChild(tooltipContentEl);
        }

        const tooltipModel = context.tooltip;
        if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        tooltipEl.classList.remove('above', 'below', 'no-transform');
        if (tooltipModel.yAlign) {
            tooltipEl.classList.add(tooltipModel.yAlign);
        } else {
            tooltipEl.classList.add('no-transform');
        }

        if (tooltipModel.body) {
            const bodyLines = tooltipModel.body.map(b => b.lines);

            let innerHtml = '';
            bodyLines.forEach(function(body, i) {
                const colors = tooltipModel.labelColors[i];
                let style = 'background: #495057';
                style += '; color: #ffffff';
                style += '; border-color: #000000';
                style += '; border-width: 2px';
                style += '; padding: 0.5rem';
                style += '; border-radius: 5px';
                style += '; word-wrap: break-word';
                const colorSquare = '<span style="border: 2px solid #ffffff; display: inline-block; width: 12px; height: 12px; margin-right: 6px; background-color: ' + colors.backgroundColor + '"></span>';
                innerHtml += '<div style="' + style + '">' + colorSquare + ' ' + body + '</div>';
            });

            tooltipContentEl.innerHTML = innerHtml;
        }

        const position = context.chart.canvas.getBoundingClientRect();
                    setTimeout(() => {
                        const tooltipWidth = tooltipEl.offsetWidth;
                        const tooltipHeight = tooltipEl.offsetHeight;
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        let left = position.left + tooltipModel.caretX;
                        if (left + tooltipWidth >= viewportWidth) {
                            left -= tooltipWidth;
                        }

                        let top = position.top + tooltipModel.caretY;
                        if (top + tooltipHeight >= viewportHeight) {
                            top -= tooltipHeight;
                        }
                        if (top < 0) {
                            top = 0;
                        }

                        tooltipEl.style.left = left + 'px';
                        tooltipEl.style.top = top + 'px';
                        tooltipEl.style.opacity = '1';
                        tooltipEl.style.position = 'fixed';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.zIndex = '2';
                    }, 0);
    },
                filter: (e: TooltipItem<'doughnut'>, index: number, array: TooltipItem<'doughnut'>[], data: ChartData) => {
                    const datasetLabels = (e.dataset as any).labels;
                    if (datasetLabels) {
                        return !!datasetLabels[e.dataIndex];
                    }
                    return !!e.label;
                },
                callbacks: {
                    label: (ctx) => {
                        const datasetLabels = (ctx.dataset as any).labels;
                        if (datasetLabels) {
                            return datasetLabels[ctx.dataIndex];
                        }
                        return ctx.label;
                    },
                    afterLabel: (ctx) => '',
                },
            },
            legend: {
                display: false,
            },
            htmlLegend: {
                display: true,
                showValue: true,
                legendValues: type === BusinessVolumeCostStateEnum.Income ? this.bvIncomeLegendValues : type === BusinessVolumeCostStateEnum.Costs ? this.bvCostsLegendValues  : undefined,
                callbacks: {
                    value: (v) => formatCurrency(v, 'de-DE', '€'),
                },
            },
        },
    });
    public BusinessVolumeChartOptions$: Observable<CustomDoughnutChartOptions> = this.businessVolumeIndexState$.pipe(map(s => this.businessVolumeChartOptions(BusinessVolumeCostStateEnum.Income, s)));
    public BusinessVolumeCostChartOptions$: Observable<CustomDoughnutChartOptions> = this.businessVolumeCostIndexState$.pipe(map(s => this.businessVolumeChartOptions(BusinessVolumeCostStateEnum.Costs, s)));


    public TargetTime$ = this.Commission$.pipe(
        switchMap((commission) =>
            commission.AdditionalData?.planedWorkingHours != null
                ? of(commission.AdditionalData.planedWorkingHours)
                : this.store.select(getLedgerImports).pipe(
                      filter(isNotNullOrUndefined),
                      map((lis) =>
                          lis
                              .filter((l) => l.CommissionId === commission.Id && l.DocumentType === LedgerImportDocumentTypes.Offer && l.Status === LedgerImportStatusEnum.AngebotAkzeptiert)
                              .map((l) => l.AccountsReceivableLedgerIds)
                              .flat(),
                      ),
                      switchMap((arlIds) => arlIds.length ? combineLatest(arlIds.map((id) => this.store.select(getAccountsReceivableLedgerById({ id })).pipe(filter(isNotNullOrUndefined)))) : of([] as AccountsReceivableLedgerEntity[])),
                      switchMap((arls) => arls.length ? this.store.select(getQuantityTypes).pipe(
                              filter(isNotNullOrUndefined),
                              map((quantityTypes) => {
                                  const hourType = quantityTypes.find((q) => q.Name === QuantityTypeNames.Hours || q.Name === QuantityTypeNames.Hours2 || q.Name === QuantityTypeNames.Hours3 || q.Name === QuantityTypeNames.Hours4);
                                  return arls.filter((a) => a.QuantityTypeId === hourType?.Id).reduce((sum, v) => sum + v.Quantity, 0) * 1000 * 60 * 60;
                              }),
                          ) : of(0),
                      ),
                  ),
        ),
        tap((v) => console.log('target,', v)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );







        // this.CommissionId$.pipe(
        // switchMap((commissionId) =>
        //     combineLatest([
        //         this.store.select(getWorkedTimesFetched).pipe(
        //             tap((fetched) => {
        //                 if (!fetched) {
        //                     this.workedTimesResolver.resolve();
        //                 }
        //             }),
        //             filter((fetched) => !!fetched),
        //             switchMap(() => this.store.select(getWorkedTimes)),
        //             map((wt) => wt.filter((w) => w.CommissionId === commissionId)),
        //         ),
        //         this.TargetTime$,
        //         this.clockInTypes$,
        //         this.timeIndexState$,
        //     ]).pipe(
        //         map(([workedTimes, targetTime, clockInTypes, timeIndexState]) => {
        //             const workedTimesByClockInType = clockInTypes
        //                 .filter((t) => t.Slug !== EnumClockInTypeSlug.workTime && t.Slug !== EnumClockInTypeSlug.commissionWorkTime)
        //                 .map((ct) => workedTimes.filter((wt) => wt.ClockInTypeId === ct.Id).reduce((sum, v) => sum + v.Timespan, 0));
        //             workedTimesByClockInType.unshift(
        //                 clockInTypes
        //                     .filter((t) => t.Slug === EnumClockInTypeSlug.workTime || t.Slug === EnumClockInTypeSlug.commissionWorkTime)
        //                     .map((ct) => workedTimes.filter((wt) => wt.ClockInTypeId === ct.Id).reduce((sum, v) => sum + v.Timespan, 0))
        //                     .reduce((sum, v) => sum + v, 0),
        //             );
        //         }))
        // ));

    private tasks$ = combineLatest([this.taskFilterValues$, this.CommissionId$]).pipe(
        switchMap(([filter, id]) =>
            this.eventDataService.GetFromCommissionsTasks$(
                [id, ...filter?.subCommissions?.map(({ id }) => id) ?? []].filter(isNotNullOrUndefined)
            )
        ),
        map(tasks => tasks.sort((a, b) => a.Id - b.Id)),
        distinctUntilChanged(
            (a, b) =>
                a.length === b.length &&
                a.every((v, i) => v.UpdatedAt.getTime() === b[i].UpdatedAt.getTime())
        ),
        shareReplay(1),
    );



    public TaskDataSets$: Observable<ChartDataset<'doughnut', number[]>[]> =
        this.tasks$.pipe(
            map(tasks => tasks.sort((a, b) => a.Id - b.Id)),
            distinctUntilChanged(
                (a, b) =>
                    a.length === b.length &&
                    a.every(
                        (v, i) =>
                            v.UpdatedAt.getTime() === b[i].UpdatedAt.getTime()
                    )
            ),
            map(tasks => {
                const notDoneStates = Object.values(taskEventStates)
                    .filter(v => v !== EventStateEnum.Done);
                const now = new Date().getTime();
                const oldTasksCount = tasks.filter(
                    t =>
                        notDoneStates.includes(t.State) &&
                        t.EventEndDate &&
                        t.EventEndDate.getTime() < now
                ).length;
                this.taskChartLegendValues.splice(
                    0,
                    this.taskChartLegendValues.length,
                    tasks.filter(t => t.State === this.taskIndexState[0].state).length,
                    tasks.filter(t => t.State === this.taskIndexState[1].state).length,
                    tasks.filter(t => t.State === this.taskIndexState[2].state).length,
                    oldTasksCount,
                    0,
                );

                const ret: ChartDataset<'doughnut', number[]>[] = tasks.length
                    ? [
                        {
                            ...defaultDataset,
                            data: [
                                tasks.filter(t => t.State === this.taskIndexState[0].state).length,
                                tasks.filter(t => t.State === this.taskIndexState[1].state).length,
                                tasks.filter(t => t.State === this.taskIndexState[2].state).length,
                                0,
                                0,
                            ],
                            backgroundColor: this.taskIndexState.map(t => t.backgroundColor),
                            borderColor: this.taskIndexState.map(t => t.borderColor),
                        },
                    ]
                    : [];
                if (oldTasksCount) {
                    ret.push({
                        ...defaultDataset,
                        data: [0, 0, 0, oldTasksCount, tasks.length - oldTasksCount],
                        backgroundColor: this.taskIndexState.map(t => t.backgroundColor),
                        borderColor: this.taskIndexState.map(t => t.borderColor),
                        weight: 0.75,
                    });
                }
                return ret;
            })
        );


    protected TasksByCommission$ = combineLatest([
        this.tasks$,
        this.store.select(getCommissionsFetched).pipe(filter(f => f)),
        this.store.select(getCommissions),
        this.taskFilterValues$,
    ]).pipe(
        map(([tasks, _, commissions, filter]) => {
            const selectedSubIds = filter?.subCommissions?.map(({ id }) => id) ?? [];
            if (selectedSubIds.length === 0) return [];

            const notDoneStates = Object.values(taskEventStates).filter(v => v !== EventStateEnum.Done);
            const now = new Date().getTime();
            const allIds = [this.CommissionId, ...selectedSubIds];
            return allIds.map(cId => {
                const ct = tasks.filter(t => t.CommissionId === cId);
                const overdue = ct.filter(t =>
                    notDoneStates.includes(t.State) && t.EventEndDate?.getTime() < now
                ).length;
                const commission = commissions.find(c => c.Id === cId)

                return {
                    toolTip: commission?.optionLabel ?? `#${cId}`,
                    label: commission?.Auftragsnummer ?? commission?.optionLabel,
                    //total: ct.length,
                    isMain: this.CommissionId === cId,
                    counts: {
                        new:        ct.filter(t => t.State === EventStateEnum.New).length,
                        inProgress: ct.filter(t => t.State === EventStateEnum.InProgress).length,
                        done:       ct.filter(t => t.State === EventStateEnum.Done).length,
                        overdue,
                    },
                };
            });
        })
    );

    private workTimesByEventTypesFromCommission$ = combineLatest([
        this.commissionEvents$,
        getFetched$(this.store, getUserToEventFetched, getUserToEvents).pipe(
            filter(isNotNullOrUndefined),
            map((u2es) => u2es.filter((u2e) => !!u2e.AdditionalData?.timespan)),
        )
    ]).pipe(
        map(([commissionEvents, u2es]) => {
            const eventTypeToWorkTime = new Map<number, number>([]);

            Object.values(commissionEvents).forEach(event => {
                const eventType = event.EventTypeId;
                if (eventType) {
                    const workTime = u2es.filter(u2e => u2e.EventId === event.Id).reduce((prev, cur) => prev + (UserToEventTimeSpanStringToHours(cur.AdditionalData.timespan) || 0), 0);
                    if (workTime) {
                        if (eventTypeToWorkTime.has(eventType)) {
                            eventTypeToWorkTime.set(eventType, eventTypeToWorkTime.get(eventType) + workTime);
                        } else {
                            eventTypeToWorkTime.set(eventType, workTime);
                        }
                    }
                }
            });
            return eventTypeToWorkTime;
        }),
    );

    protected timeChartLegendValues: number[] = [];
    public TimeSum$ = new BehaviorSubject<number>(null);
    public TimeDataSets$: Observable<ChartDataset<'doughnut', number[]>[]> = combineLatest([
        this.timeFilterValues$,
        this.CommissionId$,
        this.TargetTime$,
        getFetched$(this.store, getCommissionsFetched, getCommissions),
        getFetched$(this.store, getEventTypeFetched, getEventTypesDictionary),
        this.workTimesByEventTypesFromCommission$,
    ]).pipe(
        switchMap(([filter, commissionId, targetTime, commissions, eventTypes, commissionEventTypeToWorkTime]) => {
            const ids = [
                commissionId,
                ...(filter?.subCommissions?.map(x => x.id) ?? [])
            ].filter(isNotNullOrUndefined);
            return this.workTimesByClockInTypesFromCommissionIds$(ids).pipe(
                map(workedTimesByClockInType => ({
                    workedTimesByClockInType,
                    targetTime,
                    filter,
                    commissions,
                    commissionEventTypeToWorkTime,
                    eventTypes
                }))
            );
        }),
        map(({ workedTimesByClockInType, targetTime, filter, commissions, commissionEventTypeToWorkTime, eventTypes }) => {
            // const workedTimesByClockInType = clockInTypes
            //     .filter((t) => t.Slug !== EnumClockInTypeSlug.workTime && t.Slug !== EnumClockInTypeSlug.commissionWorkTime )
            //     .map((ct) => workedTimes.filter((wt) => wt.ClockInTypeId === ct.Id).reduce((sum, v) => sum + v.Timespan, 0));
            // workedTimesByClockInType.unshift(
            //     clockInTypes
            //         .filter((t) => t.Slug === EnumClockInTypeSlug.workTime || t.Slug === EnumClockInTypeSlug.commissionWorkTime)
            //         .map((ct) => workedTimes.filter((wt) => wt.ClockInTypeId === ct.Id).reduce((sum, v) => sum + v.Timespan, 0))
            //         .reduce((sum, v) => sum + v, 0),
            // );
            const sum = workedTimesByClockInType.reduce((sum, v) => sum + v.timespan, 0);
            this.TimeSum$.next(sum);
            const open = (targetTime - sum)  / 1000 / 60 / 60;



            this.timeChartLegendValues.splice(0, this.timeChartLegendValues.length,
                open < 0 ? 0 : open,       // Offen
                open < 0 ? open * -1 : 0,  // Abweichung
                ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => commissionEventTypeToWorkTime.get(e)),
            );

            const selectedSubIds = filter?.subCommissions?.map(({ id }) => id) ?? [];

            const ring1Entries = [
                ...workedTimesByClockInType
                    .map(group => {
                        const t = group.clockInTypes.length === 1
                            ? group.clockInTypes[0]
                            : group.clockInTypes.find(ct => ct.Slug !== EnumClockInTypeSlug.commissionWorkTime);
                        return {
                            data: group.workTimes
                                .filter(wt => wt.CommissionId === this.CommissionId)
                                .reduce((s, wt) => s + wt.Timespan, 0) / 1000 / 60 / 60,
                            label: t?.Name,
                            color: getColorClockInType(t),
                        };
                    })
                    .filter(e => e.data > 0),
                ...selectedSubIds.map((cId, i) => ({
                    data: workedTimesByClockInType
                        .flatMap(group => group.workTimes)
                        .filter(wt => wt.CommissionId === cId)
                        .reduce((s, wt) => s + wt.Timespan, 0) / 1000 / 60 / 60,
                    label: commissions.find(c => c.Id === cId)?.optionLabel ?? `#${cId}`,
                    color: this.getCommissionColor(i + 1),
                })).filter(e => e.data > 0),
            ];
            this.timeRing1EntriesCount$.next(ring1Entries.length)
            const eventColor = '#EFAC32';
            const ret = [
                {
                    ...defaultDataset,
                    data: [
                        open < 0 ? 0 : open,
                        0,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => 0),
                        ...ring1Entries.map(e => e.data),
                        0,
                    ],
                    backgroundColor: [
                        ...this.timeIndexState.slice(0, 2).map(
                            t => t.backgroundColor
                        ),
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => eventColor),
                        ...ring1Entries.map(e => e.color),
                        'transparent',
                    ],
                    labels: [
                        `Offen: ${formatNumber(open < 0 ? 0 : open, 'de-DE', '1.0-2')} Std.`,
                        null, // Abweichung (Ring 2)
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => null),
                        ...ring1Entries.map(e => `${e.label}: ${formatNumber(e.data, 'de-DE', '1.0-2')} Std.`),
                        null, // spacer
                    ],
                    borderColor: [
                        ...this.timeIndexState.slice(0, 2).map(t =>
                            t.backgroundColor === 'transparent' ? 'transparent' : colors.border
                        ),
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => colors.border),
                        ...ring1Entries.map(e =>
                            e.color === 'transparent' ? 'transparent' : colors.border
                        ),
                        'transparent',
                    ],
                },
            ];
            if (commissionEventTypeToWorkTime.size > 0) {
                ret.push({
                    ...defaultDataset,
                    data: [
                        0,  // Offen
                        0,  // Abweichung
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => commissionEventTypeToWorkTime.get(e)),
                        ...ring1Entries.map(() => 0),
                        0,  // spacer
                    ],
                    backgroundColor: [
                        'transparent',
                        colors.red,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => eventColor),
                        ...ring1Entries.map(() => 'transparent'),
                        'transparent',
                    ],
                    labels: [
                        null,
                        null,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => eventTypes[e]?.Name + ': ' + formatNumber(commissionEventTypeToWorkTime.get(e), 'de-DE', '1.0-2') + ' Std.'),
                        ...ring1Entries.map(() => null),
                        null,
                    ],
                    borderColor:  [
                        'transparent',
                        colors.border,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => colors.border),
                        ...ring1Entries.map(() => colors.border),
                        'transparent',
                    ],
                    weight: 0.75,
                });
            }

            if (open < 0) {
                const ring1Sum = (open < 0 ? 0 : open) + ring1Entries.reduce((s, e) => s + e.data, 0);
                const abweichung = open * -1;
                const spacer = ring1Sum - abweichung; // Rest damit Summe = ring1Sum

                ret.push({
                    ...defaultDataset,
                    data: [
                        0,           // Offen
                        abweichung,  // Abweichung
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => 0),
                        ...ring1Entries.map(() => 0),
                        spacer > 0 ? spacer : 0, // spacer statt 0
                    ],
                    backgroundColor: [
                        'transparent',
                        colors.red,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => 'transparent'),
                        ...ring1Entries.map(() => 'transparent'),
                        'transparent',
                    ],
                    labels: [
                        null,
                        `Abweichung: ${formatNumber(abweichung, 'de-DE', '1.0-2')} Std.`,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => null),
                        ...ring1Entries.map(() => null),
                        null,
                    ],
                    borderColor:  [
                        'transparent',
                        colors.border,
                        ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => 'transparent'),
                        ...ring1Entries.map(() => colors.border),
                        'transparent',
                    ],
                    weight: 0.75,
                });
            }
            return ret;
        }),
    );
    public TimeChartOptions: CustomDoughnutChartOptions = {
        responsive: true,
        onClick: (e, el, chart) => {
            const activePoints = chart.getElementsAtEventForMode(
                e as any,
                'nearest',
                {
                    intersect: true,
                },
                false,
            );

            if (!activePoints?.length) {
                this.timeChart?.OpenMeInPopUp();
            }
        },
        plugins: {
            title: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: function(context) {
                    let tooltipEl = document.getElementById('chartjs-tooltip');
                    let tooltipContentEl = document.getElementById('chartjs-tooltip-content');

                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-tooltip';
                        document.body.appendChild(tooltipEl);

                        tooltipContentEl = document.createElement('div');
                        tooltipContentEl.id = 'chartjs-tooltip-content';
                        tooltipEl.appendChild(tooltipContentEl);
                    }

                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = '0';
                        return;
                    }

                    tooltipEl.classList.remove('above', 'below', 'no-transform');
                    if (tooltipModel.yAlign) {
                        tooltipEl.classList.add(tooltipModel.yAlign);
                    } else {
                        tooltipEl.classList.add('no-transform');
                    }

                    if (tooltipModel.body) {
                        const bodyLines = tooltipModel.body.map(b => b.lines);

                        let innerHtml = '';
                        bodyLines.forEach(function(body, i) {
                            const colors = tooltipModel.labelColors[i];
                            let style = 'background: #495057';
                            style += '; color: #ffffff';
                            style += '; border-color: #000000';
                            style += '; border-width: 2px';
                            style += '; padding: 0.5rem';
                            style += '; border-radius: 5px';
                            style += '; word-wrap: break-word';
                            const colorSquare = '<span style="border: 2px solid #ffffff; display: inline-block; width: 12px; height: 12px; margin-right: 6px; background-color: ' + colors.backgroundColor + '"></span>';
                            innerHtml += '<div style="' + style + '">' + colorSquare + ' ' + body + '</div>';
                        });

                        tooltipContentEl.innerHTML = innerHtml;
                    }

                    const position = context.chart.canvas.getBoundingClientRect();
                    setTimeout(() => {
                        const tooltipWidth = tooltipEl.offsetWidth;
                        const tooltipHeight = tooltipEl.offsetHeight;
                        const viewportWidth = window.innerWidth;
                        const viewportHeight = window.innerHeight;

                        let left = position.left + tooltipModel.caretX;
                        if (left + tooltipWidth >= viewportWidth) {
                            left -= tooltipWidth;
                        }

                        let top = position.top + tooltipModel.caretY;
                        if (top + tooltipHeight >= viewportHeight) {
                            top -= tooltipHeight;
                        }
                        if (top < 0) {
                            top = 0;
                        }

                        tooltipEl.style.left = left + 'px';
                        tooltipEl.style.top = top + 'px';
                        tooltipEl.style.opacity = '1';
                        tooltipEl.style.position = 'fixed';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.zIndex = '2';
                    }, 0);
                },
                filter: (
                    e: TooltipItem<'doughnut'>,
                    index: number,
                    array: TooltipItem<'doughnut'>[],
                    data: ChartData
                ) => {
                    const datasetLabels = (e.dataset as any).labels;
                    if (datasetLabels) return !!datasetLabels[e.dataIndex];
                    return !!e.label;
                },
                callbacks: {
                    label: (ctx) => {
                        const datasetLabels = (ctx.dataset as any).labels;
                        if (datasetLabels) return datasetLabels[ctx.dataIndex];
                        return ctx.label;
                    },
                  //  afterLabel: () => ' Std.',
                },
            },
            legend: {
                display: false,
            },
            htmlLegend: {
                display: true,
                showValue: true,
                legendValues: this.timeChartLegendValues,
                callbacks: {
                    afterValue: () => ' Std.',
                    value: (v) => formatNumber(v, 'de-DE', '1.0-2'),
                },
            },
        },
    };

    public TimeLabels = this.timeIndexState
        .map(t => t.label)
        .filter(Boolean);
    private timeRing1EntriesCount$ = new BehaviorSubject<number>(0)
    protected TimeLabels$ = combineLatest([
        this.timeRing1EntriesCount$,
        this.workTimesByEventTypesFromCommission$,
        this.store.select(getEventTypesDictionary),
    ]).pipe(
        map(([count, commissionEventTypeToWorkTime, eventTypes]) => {
            return [
                ...this.timeIndexState.map(t => t.label),
                ...Array.from(commissionEventTypeToWorkTime.keys()).map(e => eventTypes[e]?.Name),
                // ...Array.from({length: count}).map(() => null),
                // null, // spacer
            ]
        }),
    )
    public Mobile$ = this.bs.MobileQuery;
    constructor(
        private store: Store<State>,
        private dialog: MatDialog,
        private businessVolumeResolver: BusinessVolumeResolver,
        private clockInTypeResolver: ClockInTypeResolver,
        private workedTimesResolver: WorkedTimesResolver,
        private bs: BreakpointObserverService,
        private mstr: MilestoneResolver,
        bVCNRes: BVCustomNameResolver,
        u2eRes: UserToEventResolver,
        @Inject(LOCALE_ID) private locale: string,
        protected ps: PermissionService,
        protected cls: CustomLabelService,
        protected eventDataService: EventDataService,
        private colorService: ColorService,
        private ngZone: NgZone
    ) {
        firstValueFrom(this.store.select(getBVCustomNameFetched)).then(f =>{
            if (!f) {
                bVCNRes.resolve();
            }
        })
        firstValueFrom(this.store.select(getUserToEventFetched)).then(f =>{
            if (!f) {
                u2eRes.resolve();
            }
        })
    }

    private getCommissionColor = (index: number): string => {
        if (index < commissionPositionColors.length) {
            return commissionPositionColors[index];
        }
        return this.colorService.GetColors(index + 1)[index];
    };
    private openTaskPopup(state?: EventStateEnum, onlyLate?: boolean) {
        const filter = this.taskFilterValues$.value;
        this.dialog.open<TaskBoardPopupComponent, TaskBoardPopupComponentDialogData>(TaskBoardPopupComponent, {
            ...TaskBoardPopupComponent.DefaultConfig,
            data: {
                filter: {
                    CommissionIds: [
                        this.CommissionId,
                        ...filter?.subCommissions?.map(({ id }) => id) ?? [],
                    ].filter(isNotNullOrUndefined),
                    State: state ? [state] : onlyLate ? Object.values(taskEventStates).filter((v) => v !== EventStateEnum.Done) : null,
                    MaxEventEndDate: onlyLate ? new Date() : null,
                },
            },
        });
    }

    OnTaskIconClick(event) {
        event.stopPropagation();
        const filter = this.taskFilterValues$.value;
        this.dialog.open<TaskBoardPopupComponent, TaskBoardPopupComponentDialogData>(TaskBoardPopupComponent, {
            ...TaskBoardPopupComponent.DefaultConfig,
            data: {
                filter: {
                    CommissionIds: [
                        this.CommissionId,
                        ...filter?.subCommissions?.map(({ id }) => id) ?? [],
                    ].filter(isNotNullOrUndefined),
                },
                showSortButton: true,
            },
        });
    }

    /*
    protected openBVPopup(status: BusinessVolumeStatusEnum, type: BusinessVolumeCostStateEnum) {
        this.BVListDialogRef = this.dialog.open<CommissionBusinesVolumeListComponent, CommissionBusinesVolumeListComponentDialogData>(CommissionBusinesVolumeListComponent, {
            ...CommissionBusinesVolumeListComponent.DefaultConfig,
            data: {
                commissionId: this.CommissionId,
                defaultFilter: {
                    type,
                    status: status ? [{ id: status, label: BusinessVolumeStatusEnumNameMap.get(status) }] : [],
                },
            },
        });
    }
    */
    protected async openBVPopup(status: BusinessVolumeStatusEnum[], type: BusinessVolumeCostStateEnum) {

        const commissions = await firstValueFrom(this.store.select(getCommissionDictionary));

        this.dialog.open<BusinessVolumesDialogComponent, ExportBusinessVolumeDialogComponentDialogData>(BusinessVolumesDialogComponent, {
            data: {
                Headline: type === BusinessVolumeCostStateEnum.Income ? "Umsätze (Netto)" : "Kosten (Netto)",
                CommissionId: this.CommissionId,
                Type: type,
                Status: status || null,
                FilterValues: { [FilterTypes.SubCommissions]: type === BusinessVolumeCostStateEnum.Income ?
                        [...this.bvFilterValues$.value.commissions,
                            {
                                label: commissions[this.CommissionId]?.optionLabel,
                                id: this.CommissionId,
                            }] :
                       [...this.bvCostFilterValues$.value.commissions,
                           {
                               label: commissions[this.CommissionId]?.optionLabel,
                               id: this.CommissionId,
                           }] }

                // filteredSubCommissions: [
                //     ...(this.timeFilterValues$.value[FilterTypes.SubCommissions]?.map(({ id }) => id) ?? []),
                //     this.CommissionId,
                // ],
            },
            ...BusinessVolumesDialogComponent.DefaultConfig,
        });
    }
    public OpenChartPopUp(chart: DoughnutChartWrapperComponent) {
        console.log({ chart });
        const dialogRef = this.dialog.open<DoughnutChartWrapperComponent, DoughnutChartWrapperComponentDialogData>(DoughnutChartWrapperComponent, {
            ...DoughnutChartWrapperComponent.DefaultConfig,
            data: {
                Datasets: chart.Datasets,
                CenterTemplate: chart.CenterTemplate,
                Labels: chart.Labels,
                Options: chart.Options,
                Headline: chart.Headline,
                Subline: chart.Subline,
            },
        });
    }
    OpenFilePreview(fileId: number) {
        if (this.filePreviewDialog?.getState() === MatDialogState.OPEN) {
            this.filePreviewDialog.close();
        }
        this.filePreviewDialog = this.dialog.open<DaveFilePreviewComponent, DaveFilePreviewComponentDialogData>(DaveFilePreviewComponent, {
            ...DaveFilePreviewComponent.DefaultConfig,
            data: {
                fileId,
            },
        });
    }

    public OpenUser2CommissionList() {
        this.Commission$.pipe(first()).subscribe((commission) => {
            this.dialog.open<UserToCommissionListComponent, UserToCommissionListComponentDialogData>(UserToCommissionListComponent, {
                ...UserToCommissionListComponent.DefaultConfig,
                data: {
                    commissionId: commission.Id,
                    filteredSubCommissions: [
                        ...(this.timeFilterValues$.value[FilterTypes.SubCommissions]?.map(({ id }) => id) ?? []),
                        this.CommissionId,
                    ],
                },
            });
        });
    }

    protected readonly BusinessVolumeCostStateEnum = BusinessVolumeCostStateEnum;
    @Input() DeleteMileStonePermission!: boolean;
    @Input() EditMileStonePermission!: boolean;
    @Input() CreateMileStonePermission!: boolean;
    @Input() GetMileStonePermission!: boolean;
    protected canGetBV$ = this.ps.Has$(this.ps.Permissions.GetBusinessVolume).pipe(switchMap(hasPpermission => hasPpermission ? of(true) : this._entityRoles.pipe(map(er => er.some(er => er.Permissions.some(p => p.name === EntityRolePermissionNameEnum.GetBusinessVolume))))));

    @Input() set entityRoles(value: EntityRoleEntity[] | null) {
        this._entityRoles.next(value);
    }
    private _entityRoles = new BehaviorSubject<EntityRoleEntity[]>([]);
    protected readonly colors = colors;
    private lastMouse = { x: -1, y: -1 };

    private readonly onMouseMove = (e: MouseEvent) => {
        this.lastMouse.x = e.clientX;
        this.lastMouse.y = e.clientY;
    };

    private get allCharts(): DoughnutChartWrapperComponent[] {
        return [this.taskChart, this.timeChart, this.bvChart, this.bvCostChart]
            .filter(isNotNullOrUndefined);
    }

    private readonly onScroll = () => {
        const { x, y } = this.lastMouse;
        const elementUnderMouse = document.elementFromPoint(x, y);

        const hoveredChart = this.allCharts
            .map(c => c.DoughnutChartComponent?.Chart)
            .find(chart => chart?.canvas === elementUnderMouse);

        if (hoveredChart) {
            hoveredChart.canvas.dispatchEvent(new MouseEvent('mousemove', {
                clientX: x,
                clientY: y,
                bubbles: true,
            }));
        } else {
            this.hideTooltip();
        }
    };

    private hideTooltip(): void {
        const el = document.getElementById('chartjs-tooltip');
        if (el) {
            el.style.opacity = '0';
        }

        const chart = this.timeChart?.DoughnutChartComponent?.Chart;
        if (chart) {
            chart.tooltip?.setActiveElements([], { x: 0, y: 0 });
            chart.setActiveElements([]);
            chart.update('none');
        }
    }

    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            window.addEventListener('mousemove', this.onMouseMove, { passive: true });
            window.addEventListener('scroll', this.onScroll, true);
        });
        combineLatest([
            getFetched$(this.store, getCommissionsFetched, getCommissions),
            this.CommissionId$
        ]).pipe(
            map(([commissions, commissionId]) => commissions.filter(c => c.ParentId === commissionId)),
            take(1),
        ).subscribe(childCommissions => {
            if (childCommissions.length > 0) {
                this.isSyncing = true;
                this.bvFilterValues$.next({
                    ...this.bvFilterValues$.getValue(),
                    commissions: childCommissions.map(c => ({ label: c.optionLabel, id: c.Id })),
                });
                this.bvCostFilterValues$.next({
                    ...this.bvCostFilterValues$.getValue(),
                    commissions: childCommissions.map(c => ({ label: c.optionLabel, id: c.Id })),
                });
                this.taskFilterValues$.next({
                    ...this.taskFilterValues$.getValue(),
                    subCommissions: childCommissions.map(c => ({ label: c.optionLabel, id: c.Id })),
                });
                this.timeFilterValues$.next({
                    ...this.timeFilterValues$.getValue(),
                    subCommissions: childCommissions.map(c => ({ label: c.optionLabel, id: c.Id })),
                });
                this.isSyncing = false;
            }
            this.ensureWorkedTimesLoaded$
                .pipe(takeUntil(this.destroy$))
                .subscribe();
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        window.removeEventListener('mousemove', this.onMouseMove);
        window.removeEventListener('scroll', this.onScroll, true);
        document.getElementById('chartjs-tooltip')?.remove();
    }
}
